// Additional products from Exelvia_Product_List PDF — deduplicated against existing catalog
export const PDF_LIST_PRODUCTS = [
  {
    "id": "ppdf0001",
    "name": "Ifosfamide for Inj. with Mesna Inj. (combipack)",
    "generic": "Ifosfamide Mesna Combipack",
    "strength": "1 GM",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Ifosfamide for Inj. with Mesna Inj. (combipack) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0002",
    "name": "Carfilzomib Sterlized Lyophilized Powder for Injection",
    "generic": "Carfilzomib Sterlized Lyophilized Powder",
    "strength": "60 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Carfilzomib Sterlized Lyophilized Powder for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0003",
    "name": "Vancomycin Hydrochloride for Intravenous Infusion",
    "generic": "Vancomycin Hydrochloride Intravenous Infusion",
    "strength": "500 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Vancomycin Hydrochloride for Intravenous Infusion — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0004",
    "name": "Vancomycin Hydrochloride for Intravenous Infusion",
    "generic": "Vancomycin Hydrochloride Intravenous Infusion",
    "strength": "1000 MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Vancomycin Hydrochloride for Intravenous Infusion — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0005",
    "name": "Ifosfamide for Inj. with Mesna Inj. (combipack)",
    "generic": "Ifosfamide Mesna Combipack",
    "strength": "2G",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Ifosfamide for Inj. with Mesna Inj. (combipack) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0006",
    "name": "Methylcobalamin, Thiamine Hydrochloride, Pyridoxin 1500 Mcg Hydrochloride, Niacinamide & D-panthenol Injection",
    "generic": "Methylcobalamin",
    "strength": "1500 mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Thiamine Hydrochloride, Pyridoxin 1500 Mcg Hydrochloride, Niacinamide & D-panthenol Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0007",
    "name": "Diclofenac Injection 25 Mg",
    "generic": "Diclofenac 25 Mg",
    "strength": "3ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Diclofenac Injection 25 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0008",
    "name": "Diclofenac Injection 75 Mg",
    "generic": "Diclofenac 75 Mg",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Diclofenac Injection 75 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0009",
    "name": "Ondansetron Injection 2 Mg",
    "generic": "Ondansetron 2 Mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Ondansetron Injection 2 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0010",
    "name": "Ranitidine Hydrochloride Injection 25 Mg",
    "generic": "Ranitidine Hydrochloride 25 Mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Ranitidine Hydrochloride Injection 25 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0011",
    "name": "Drotaverine Injection 40 Mg",
    "generic": "Drotaverine 40 Mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Drotaverine Injection 40 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0012",
    "name": "Piroxicam Injection 20 Mg",
    "generic": "Piroxicam 20 Mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Piroxicam Injection 20 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0013",
    "name": "Paracetamol Injection 150 Mg",
    "generic": "Paracetamol 150 Mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol Injection 150 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0014",
    "name": "Ketorolac Tromethamine Injection 30 Mg",
    "generic": "Ketorolac Tromethamine 30 Mg",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Ketorolac Tromethamine Injection 30 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0015",
    "name": "Betamethasone Injection 4 Mg",
    "generic": "Betamethasone 4 Mg",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Betamethasone Injection 4 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0016",
    "name": "Frusemide Injection 10 Mg",
    "generic": "Frusemide 10 Mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Frusemide Injection 10 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0017",
    "name": "Metoclopramide Injection 5 Mg",
    "generic": "Metoclopramide 5 Mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Metoclopramide Injection 5 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0018",
    "name": "Iron Sucrose Injection 20 Mg",
    "generic": "Iron Sucrose 20 Mg",
    "strength": "5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Iron Sucrose Injection 20 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0019",
    "name": "Injection of Etofyllin and Theophyllin 84.7 Mg",
    "generic": "Of Etofyllin and Theophyllin 84 7 Mg",
    "strength": "2 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Injection of Etofyllin and Theophyllin 84.7 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0020",
    "name": "Α-β Arteether Injection 150 Mg",
    "generic": "Α-β Arteether 150 Mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Α-β Arteether Injection 150 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0021",
    "name": "Cholecalciferol Injection Vitamin D3 6000000 Iu",
    "generic": "Cholecalciferol Vitamin D3 6000000 Iu",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Cholecalciferol Injection Vitamin D3 6000000 Iu — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0022",
    "name": "Cholecalciferol Injection Vitamin D3 3000000 Iu",
    "generic": "Cholecalciferol Vitamin D3 3000000 Iu",
    "strength": "1 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Cholecalciferol Injection Vitamin D3 3000000 Iu — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0023",
    "name": "Citicoline Injection 250mg",
    "generic": "Citicoline 250mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Citicoline Injection 250mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0024",
    "name": "Citicoline Injection 250 Mg",
    "generic": "Citicoline 250 Mg",
    "strength": "4ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Citicoline Injection 250 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0025",
    "name": "Etamsylate Injection 250 Mg",
    "generic": "Etamsylate 250 Mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Etamsylate Injection 250 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0026",
    "name": "Pheniramine Maleate Injection 22.75mg",
    "generic": "Pheniramine Maleate 22 75mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Pheniramine Maleate Injection 22.75mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0027",
    "name": "Promethazine Hydrochloride Injection 25mg",
    "generic": "Promethazine Hydrochloride 25mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Promethazine Hydrochloride Injection 25mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0028",
    "name": "Dicyclomine Injection 10mg",
    "generic": "Dicyclomine 10mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Dicyclomine Injection 10mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0029",
    "name": "Artemether Injection 40mg",
    "generic": "Artemether 40mg",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Artemether Injection 40mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0030",
    "name": "Artemether Injection 80mg",
    "generic": "Artemether 80mg",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Artemether Injection 80mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0031",
    "name": "Amikacin Sulphate Injection 500mg",
    "generic": "Amikacin Sulphate 500mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amikacin Sulphate Injection 500mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0032",
    "name": "Amikacin Sulphate Injection 250mg",
    "generic": "Amikacin Sulphate 250mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amikacin Sulphate Injection 250mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0033",
    "name": "Amikacin Sulphate Injection 100mg",
    "generic": "Amikacin Sulphate 100mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amikacin Sulphate Injection 100mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0034",
    "name": "Triamcinolone Acetonide Injection 40mg",
    "generic": "Triamcinolone Acetonide 40mg",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Orthopaedics",
    "pack": "As per regulatory specification",
    "desc": "Triamcinolone Acetonide Injection 40mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0035",
    "name": "Dexamethasone Injection 4.0mg",
    "generic": "Dexamethasone 4 0mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Dexamethasone Injection 4.0mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0036",
    "name": "Gentamycin Injection 40mg",
    "generic": "Gentamycin 40mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Gentamycin Injection 40mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0037",
    "name": "Levetiracetam Injection 100mg",
    "generic": "Levetiracetam 100mg",
    "strength": "5ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Levetiracetam Injection 100mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0038",
    "name": "Adrenaline Bi Tartrate Injection 1.8mg",
    "generic": "Adrenaline Bi Tartrate 1 8mg",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Adrenaline Bi Tartrate Injection 1.8mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0039",
    "name": "Methylcobalamin Injection 500mcg",
    "generic": "Methylcobalamin 500mcg",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin Injection 500mcg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0040",
    "name": "Methylcobalamin Injection 2500mcg",
    "generic": "Methylcobalamin 2500mcg",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin Injection 2500mcg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0041",
    "name": "Heparin Sodium Injection ( Vial) 5000 Iu",
    "generic": "Heparin Sodium Vial 5000 Iu",
    "strength": "5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Heparin Sodium Injection ( Vial) 5000 Iu — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0042",
    "name": "Tranexamic Acid Injection (. Amp.) 100mg",
    "generic": "Tranexamic Acid Amp 100mg",
    "strength": "5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Tranexamic Acid Injection (. Amp.) 100mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0043",
    "name": "Nandrolone Decanoate Injection ( Amp.) 50 Mg",
    "generic": "Nandrolone Decanoate Amp 50 Mg",
    "strength": "1 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Orthopaedics",
    "pack": "As per regulatory specification",
    "desc": "Nandrolone Decanoate Injection ( Amp.) 50 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0044",
    "name": "Nandrolone Decanoate Injection ( Amp.) 25 Mg",
    "generic": "Nandrolone Decanoate Amp 25 Mg",
    "strength": "1 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Orthopaedics",
    "pack": "As per regulatory specification",
    "desc": "Nandrolone Decanoate Injection ( Amp.) 25 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0045",
    "name": "Fluphenazine Decanoate Injection ( Amp.) 25 Mg",
    "generic": "Fluphenazine Decanoate Amp 25 Mg",
    "strength": "1 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Psychiatry",
    "pack": "As per regulatory specification",
    "desc": "Fluphenazine Decanoate Injection ( Amp.) 25 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0046",
    "name": "Haloperidol Injection ( Ampoule) 5mg",
    "generic": "Haloperidol Ampoule 5mg",
    "strength": "1 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Psychiatry",
    "pack": "As per regulatory specification",
    "desc": "Haloperidol Injection ( Ampoule) 5mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0047",
    "name": "Haloperidol Injection ( Ampoule) 10mg",
    "generic": "Haloperidol Ampoule 10mg",
    "strength": "1 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Psychiatry",
    "pack": "As per regulatory specification",
    "desc": "Haloperidol Injection ( Ampoule) 10mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0048",
    "name": "Haloperidol Decanoate Injection ( Ampoule) 50 Mg",
    "generic": "Haloperidol Decanoate Ampoule 50 Mg",
    "strength": "1 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Psychiatry",
    "pack": "As per regulatory specification",
    "desc": "Haloperidol Decanoate Injection ( Ampoule) 50 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0049",
    "name": "Lignocaine Injection 21.3mg",
    "generic": "Lignocaine 21 3mg",
    "strength": "2%",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Lignocaine Injection 21.3mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0050",
    "name": "Lincomycin Injection Ampoule 300mg",
    "generic": "Lincomycin Ampoule 300mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Lincomycin Injection Ampoule 300mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0051",
    "name": "Frusemide Injection",
    "generic": "Frusemide",
    "strength": "10 mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Frusemide Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0052",
    "name": "Ondansetron Injection 2 Mg",
    "generic": "Ondansetron 2 Mg",
    "strength": "10ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Ondansetron Injection 2 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0053",
    "name": "Ondansetron Injection 2 Mg",
    "generic": "Ondansetron 2 Mg",
    "strength": "4ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Ondansetron Injection 2 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0054",
    "name": "Metoclopramide Injection 5 Mg",
    "generic": "Metoclopramide 5 Mg",
    "strength": "10 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Metoclopramide Injection 5 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0055",
    "name": "Methylcobalamin, Thiamine Hydrochloride, Pyridoxine 1000 Mcg Hydrochloride, Niacinamide& D-panthenol Injection",
    "generic": "Methylcobalamin",
    "strength": "1000 mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Thiamine Hydrochloride, Pyridoxine 1000 Mcg Hydrochloride, Niacinamide& D-panthenol Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0056",
    "name": "Injection of Etofylline and Theophylline 84.7 Mg",
    "generic": "Of Etofylline and Theophylline 84 7 Mg",
    "strength": "2 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Injection of Etofylline and Theophylline 84.7 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0057",
    "name": "Nandrolone Decanoate Injection - 100 Mg",
    "generic": "Nandrolone Decanoate - 100 Mg",
    "strength": "100MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Orthopaedics",
    "pack": "As per regulatory specification",
    "desc": "Nandrolone Decanoate Injection - 100 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0058",
    "name": "Methylcobalamin, Pyridoxine Hydrochloride, Niacinamide and 1500 Mcg D-panthenol Injection",
    "generic": "Methylcobalamin",
    "strength": "1500 mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Pyridoxine Hydrochloride, Niacinamide and 1500 Mcg D-panthenol Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0059",
    "name": "Hydroxocobalamin Injection 1000mcg",
    "generic": "Hydroxocobalamin 1000mcg",
    "strength": "1ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Hydroxocobalamin Injection 1000mcg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0060",
    "name": "Hydroxocobalamin Injection 1000mcg",
    "generic": "Hydroxocobalamin 1000mcg",
    "strength": "5ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Hydroxocobalamin Injection 1000mcg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0061",
    "name": "Gentamycin Sulphate Injection Vial 80mg",
    "generic": "Gentamycin Sulphate Vial 80mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Gentamycin Sulphate Injection Vial 80mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0062",
    "name": "Gentamycin Sulphate Injection Vial 80mg",
    "generic": "Gentamycin Sulphate Vial 80mg",
    "strength": "10ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Gentamycin Sulphate Injection Vial 80mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0063",
    "name": "Gentamycin Sulphate Injection Vial 80mg",
    "generic": "Gentamycin Sulphate Vial 80mg",
    "strength": "20ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Gentamycin Sulphate Injection Vial 80mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0064",
    "name": "Gentamycin Sulphate Injection Vial 80mg",
    "generic": "Gentamycin Sulphate Vial 80mg",
    "strength": "30ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Gentamycin Sulphate Injection Vial 80mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0065",
    "name": "Dexamethasone Sodium Phosphate Injection Vial 4.0mg",
    "generic": "Dexamethasone Sodium Phosphate Vial 4 0mg",
    "strength": "10ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Dexamethasone Sodium Phosphate Injection Vial 4.0mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0066",
    "name": "Dexamethasone Sodium Phosphate Injection Vial 4.0mg",
    "generic": "Dexamethasone Sodium Phosphate Vial 4 0mg",
    "strength": "20ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Dexamethasone Sodium Phosphate Injection Vial 4.0mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0067",
    "name": "Dexamethasone Sodium Phosphate Injection Vial 4.0mg",
    "generic": "Dexamethasone Sodium Phosphate Vial 4 0mg",
    "strength": "30ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Dexamethasone Sodium Phosphate Injection Vial 4.0mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0068",
    "name": "Injection of Vitamin B1, B6, B12 & D-panthenol Ampoule 33mg",
    "generic": "Of Vitamin B1",
    "strength": "3ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Injection of Vitamin B1, B6, B12 & D-panthenol Ampoule 33mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0069",
    "name": "Torsemide Injection /ml 2ml Ampoule 10mg",
    "generic": "Torsemide /ml 2ml Ampoule 10mg",
    "strength": "10MG",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Torsemide Injection /ml 2ml Ampoule 10mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0070",
    "name": "Heparin Injection 1000 Iu",
    "generic": "Heparin 1000 Iu",
    "strength": "5000 IU/5ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Heparin Injection 1000 Iu — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0071",
    "name": "Amikacin Sulfate Injection 500mg",
    "generic": "Amikacin Sulfate 500mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amikacin Sulfate Injection 500mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0072",
    "name": "Amikacin Sulfate Injection 250mg",
    "generic": "Amikacin Sulfate 250mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amikacin Sulfate Injection 250mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0073",
    "name": "Amikacin Sulfate Injection 100mg",
    "generic": "Amikacin Sulfate 100mg",
    "strength": "2ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amikacin Sulfate Injection 100mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0074",
    "name": "Heparin Injection Vial 5000 Iu",
    "generic": "Heparin Vial 5000 Iu",
    "strength": "5 ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Heparin Injection Vial 5000 Iu — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0075",
    "name": "Ascorbic Acid Injection",
    "generic": "Ascorbic Acid",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ascorbic Acid Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0076",
    "name": "Ceftriaxone for Injection. 1gm",
    "generic": "Ceftriaxone 1gm",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone for Injection. 1gm — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0077",
    "name": "Diclofenec Sodium Injection 75 Mg/3ml",
    "generic": "Diclofenec Sodium 75 Mg/3ml",
    "strength": "25gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Diclofenec Sodium Injection 75 Mg/3ml — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0078",
    "name": "Phenytoin Sodium Injection",
    "generic": "Phenytoin Sodium",
    "strength": "50mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Phenytoin Sodium Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0079",
    "name": "Ceftriaxone for Injection",
    "generic": "Ceftriaxone",
    "strength": "2000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0080",
    "name": "Ampicillin & Sulbactam for Injection",
    "generic": "Ampicillin & Sulbactam",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ampicillin & Sulbactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0081",
    "name": "Cefoperazone & Sulbactam for Injection",
    "generic": "Cefoperazone & Sulbactam",
    "strength": "2000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefoperazone & Sulbactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0082",
    "name": "Cefoperazone & Sulbactam for Injection",
    "generic": "Cefoperazone & Sulbactam",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefoperazone & Sulbactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0083",
    "name": "Ampicillin & Sulbactam for Injection",
    "generic": "Ampicillin & Sulbactam",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ampicillin & Sulbactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0084",
    "name": "B-complex Injection",
    "generic": "B-complex",
    "strength": "33.3mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "B-complex Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0085",
    "name": "Ascorbic Acid Injection. & Thiamine Hydrochloride Injection",
    "generic": "Ascorbic Acid & Thiamine Hydrochloride",
    "strength": "3ml",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ascorbic Acid Injection. & Thiamine Hydrochloride Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0086",
    "name": "Piperacillin & Tazobactam Injection",
    "generic": "Piperacillin & Tazobactam",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Piperacillin & Tazobactam Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0087",
    "name": "Methylcobalamin, Niacinamid & Folic Acid Injection",
    "generic": "Methylcobalamin",
    "strength": "2500mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Niacinamid & Folic Acid Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0088",
    "name": "Glutathion for Injection",
    "generic": "Glutathion",
    "strength": "2000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Glutathion for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0089",
    "name": "Glutathion for Injection",
    "generic": "Glutathion",
    "strength": "1200mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Glutathion for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0090",
    "name": "Artemether Injection",
    "generic": "Artemether",
    "strength": "80mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Artemether Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0091",
    "name": "Amoxicillin Sodium",
    "generic": "Amoxicillin Sodium",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxicillin Sodium — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0092",
    "name": "Ceftriaxone Sodium Eq. to Anhydrous Ceftriaxone",
    "generic": "Ceftriaxone Sodium Eq to Anhydrous Ceftriaxone",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium Eq. to Anhydrous Ceftriaxone — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0093",
    "name": "Vitamin C Injection + Methylcobalamin, Folic Acid & Niacinamide 1500mg Injection. (part-i)",
    "generic": "Vitamin C + Methylcobalamin",
    "strength": "1500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Vitamin C Injection + Methylcobalamin, Folic Acid & Niacinamide 1500mg Injection. (part-i) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0094",
    "name": "Ceftazidime for Injection",
    "generic": "Ceftazidime",
    "strength": "250mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftazidime for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0095",
    "name": "Ceftazidime for Injection",
    "generic": "Ceftazidime",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftazidime for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0096",
    "name": "Clarithromycin for Injection 500 Mg",
    "generic": "Clarithromycin 500 Mg",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Clarithromycin for Injection 500 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0097",
    "name": "Meropenem &tazobactam; for Injection with Edta",
    "generic": "Meropenem &tazobactam; Edta",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Meropenem &tazobactam; for Injection with Edta — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0098",
    "name": "Meropenem & Tazobactam for Injection",
    "generic": "Meropenem & Tazobactam",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Meropenem & Tazobactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0099",
    "name": "Doripenem for Injection",
    "generic": "Doripenem",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Doripenem for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0100",
    "name": "Ceftizoxime and Tazobactam for Injection",
    "generic": "Ceftizoxime and Tazobactam",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftizoxime and Tazobactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0101",
    "name": "Pantoprazole for Injection 40 Mg",
    "generic": "Pantoprazole 40 Mg",
    "strength": "40mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Pantoprazole for Injection 40 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0102",
    "name": "Rabeprazole Sodium for Injection. 20 Mg",
    "generic": "Rabeprazole Sodium 20 Mg",
    "strength": "20mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Rabeprazole Sodium for Injection. 20 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0103",
    "name": "Camylofin Dihydrochloride & Diclofenac Sodium Injection",
    "generic": "Camylofin Dihydrochloride & Diclofenac Sodium",
    "strength": "25mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Camylofin Dihydrochloride & Diclofenac Sodium Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0104",
    "name": "Diclofenac Sodium & Thiocolchicoside Injection",
    "generic": "Diclofenac Sodium & Thiocolchicoside",
    "strength": "37.5mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Diclofenac Sodium & Thiocolchicoside Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0105",
    "name": "Amoxycillin & Potassium Clavulante Injection",
    "generic": "Amoxycillin & Potassium Clavulante",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin & Potassium Clavulante Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0106",
    "name": "Ceftriaxone Injection",
    "generic": "Ceftriaxone",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0107",
    "name": "Cefuroxime Injection",
    "generic": "Cefuroxime",
    "strength": "1500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefuroxime Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0108",
    "name": "Cefoperazone &sulbactam; for Injection",
    "generic": "Cefoperazone &sulbactam;",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefoperazone &sulbactam; for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0109",
    "name": "Amoxycillin & Potassium Clavulanate Injection",
    "generic": "Amoxycillin & Potassium Clavulanate",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin & Potassium Clavulanate Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0110",
    "name": "Seftridone-s 1.5 Gm Injection",
    "generic": "Seftridone-s 1 5 Gm",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Seftridone-s 1.5 Gm Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0111",
    "name": "Cefoperazone & Tazobactam for Injection",
    "generic": "Cefoperazone & Tazobactam",
    "strength": "2000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefoperazone & Tazobactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0112",
    "name": "Ampicillin and Tazobactam for Injection",
    "generic": "Ampicillin and Tazobactam",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ampicillin and Tazobactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0113",
    "name": "Cefepime & Tazobactam for Injection",
    "generic": "Cefepime & Tazobactam",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefepime & Tazobactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0114",
    "name": "Ceftriaxone & Tazobactam for Injection",
    "generic": "Ceftriaxone & Tazobactam",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone & Tazobactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0115",
    "name": "Cefoperazone & Sulbactam for Injection 1500 Mg",
    "generic": "Cefoperazone & Sulbactam 1500 Mg",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefoperazone & Sulbactam for Injection 1500 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0116",
    "name": "Ceftriaxone Injection. 1 Gm",
    "generic": "Ceftriaxone 1 Gm",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Injection. 1 Gm — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0117",
    "name": "Iron Sucrose Injection",
    "generic": "Iron Sucrose",
    "strength": "20mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Iron Sucrose Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0118",
    "name": "Pantoprazone for Injection 40 Mg",
    "generic": "Pantoprazone 40 Mg",
    "strength": "40mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Pantoprazone for Injection 40 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0119",
    "name": "Diclofenec Sodium Injection. 1 Ml",
    "generic": "Diclofenec Sodium 1 Ml",
    "strength": "75mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Diclofenec Sodium Injection. 1 Ml — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0120",
    "name": "Ceftriaxone & Sulbactam for Injection",
    "generic": "Ceftriaxone & Sulbactam",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone & Sulbactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0121",
    "name": "Piperacillin & Tazobactam Injection",
    "generic": "Piperacillin & Tazobactam",
    "strength": "4000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Piperacillin & Tazobactam Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0122",
    "name": "Levosulpiride Injection",
    "generic": "Levosulpiride",
    "strength": "25mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Levosulpiride Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0123",
    "name": "Piroxicam Injection",
    "generic": "Piroxicam",
    "strength": "20mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Piroxicam Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0124",
    "name": "Ketorolac Tromethamine Injection. Ketralgin Injection",
    "generic": "Ketorolac Tromethamine Ketralgin",
    "strength": "5000I.U.",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Ketorolac Tromethamine Injection. Ketralgin Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0125",
    "name": "Octreotide Acetate Injection",
    "generic": "Octreotide Acetate",
    "strength": "50mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Octreotide Acetate Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0126",
    "name": "Aztreonam for Injection",
    "generic": "Aztreonam",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Aztreonam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0127",
    "name": "Cerebroprotein Hydrolysate for Injection 60 Mg",
    "generic": "Cerebroprotein Hydrolysate 60 Mg",
    "strength": "2100mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Cerebroprotein Hydrolysate for Injection 60 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0128",
    "name": "Clindamycin Phosphate Injection",
    "generic": "Clindamycin Phosphate",
    "strength": "150mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Clindamycin Phosphate Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0129",
    "name": "Ceftazidime & Tazobactam Injection",
    "generic": "Ceftazidime & Tazobactam",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftazidime & Tazobactam Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0130",
    "name": "Meropenem& Sulbactam for Injection 1500 Mg",
    "generic": "Meropenem& Sulbactam 1500 Mg",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Meropenem& Sulbactam for Injection 1500 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0131",
    "name": "Meropenem for Injection. 1000 Mg",
    "generic": "Meropenem 1000 Mg",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Meropenem for Injection. 1000 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0132",
    "name": "Ceftazidime & Sulbactum Injection",
    "generic": "Ceftazidime & Sulbactum",
    "strength": "2000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftazidime & Sulbactum Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0133",
    "name": "Ceftriaxone Sodium for Injection. 250 Mg",
    "generic": "Ceftriaxone Sodium 250 Mg",
    "strength": "250mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium for Injection. 250 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0134",
    "name": "Ceftriaxone Sodium for Injection. 500 Mg",
    "generic": "Ceftriaxone Sodium 500 Mg",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium for Injection. 500 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0135",
    "name": "Ceftriaxone Sodium & Sulbactam Sodium for Injection 375 Mg",
    "generic": "Ceftriaxone Sodium & Sulbactam Sodium 375 Mg",
    "strength": "250mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium & Sulbactam Sodium for Injection 375 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0136",
    "name": "Ceftriaxone Sodium & Sulbactam for Injection 750 Mg",
    "generic": "Ceftriaxone Sodium & Sulbactam 750 Mg",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium & Sulbactam for Injection 750 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0137",
    "name": "Ceftriaxone Sodium & Tazobactam Sodium for Injection 281.25 Mg",
    "generic": "Ceftriaxone Sodium & Tazobactam Sodium 281 25 Mg",
    "strength": "250mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium & Tazobactam Sodium for Injection 281.25 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0138",
    "name": "Ceftriaxone Sodium & Tazobactam Sodium for Injection 1125 Mg",
    "generic": "Ceftriaxone Sodium & Tazobactam Sodium 1125 Mg",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium & Tazobactam Sodium for Injection 1125 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0139",
    "name": "Sterile Azithromycin for Injection. 500 Mg/5ml. for IV Infusion 500mg/5ml Only)",
    "generic": "Sterile Azithromycin 500 Mg/5ml IV Infusion 500mg/5ml Only",
    "strength": "5ML",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Sterile Azithromycin for Injection. 500 Mg/5ml. for IV Infusion 500mg/5ml Only) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0140",
    "name": "Amikacin Sulphate Injection. 500 Mg",
    "generic": "Amikacin Sulphate 500 Mg",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amikacin Sulphate Injection. 500 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0141",
    "name": "Amikacin Sulphate Injection. 100 Mg",
    "generic": "Amikacin Sulphate 100 Mg",
    "strength": "100mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amikacin Sulphate Injection. 100 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0142",
    "name": "Tramadol HCL Injection 100 Mg/2ml",
    "generic": "Tramadol HCL 100 Mg/2ml",
    "strength": "50mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Tramadol HCL Injection 100 Mg/2ml — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0143",
    "name": "Cholecalciferol Injection. (600,000 Iu/ml)",
    "generic": "Cholecalciferol 600",
    "strength": "600000I.U.",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Cholecalciferol Injection. (600,000 Iu/ml) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0144",
    "name": "Artemether Injection",
    "generic": "Artemether",
    "strength": "40mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Artemether Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0145",
    "name": "Ceftriaxone Sodium",
    "generic": "Ceftriaxone Sodium",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0146",
    "name": "Thiocolchicoside",
    "generic": "Thiocolchicoside",
    "strength": "2mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Thiocolchicoside — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0147",
    "name": "Methylcobalamin 1500 Mcg Injection",
    "generic": "Methylcobalamin 1500 Mcg",
    "strength": "1500mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin 1500 Mcg Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0148",
    "name": "Methylcobalamin 2500 Mcg Injection",
    "generic": "Methylcobalamin 2500 Mcg",
    "strength": "2500mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin 2500 Mcg Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0149",
    "name": "Calcitriol Injection",
    "generic": "Calcitriol",
    "strength": "0.25mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcitriol Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0150",
    "name": "Citicoline Sodium Injection",
    "generic": "Citicoline Sodium",
    "strength": "250mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Citicoline Sodium Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0151",
    "name": "Gentamicin Sulphate Injection",
    "generic": "Gentamicin Sulphate",
    "strength": "80mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Gentamicin Sulphate Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0152",
    "name": "Methylcobalamin, Thiamine HCL, Pyridoxine HCL & Niacinamide 1000mcg",
    "generic": "Methylcobalamin",
    "strength": "1000mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Thiamine HCL, Pyridoxine HCL & Niacinamide 1000mcg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0153",
    "name": "Methylcobalamin, Pyridoxine HCL, Niacinamide & D-panthenol 1000mcg with Benzyl Alcohol Injection",
    "generic": "Methylcobalamin",
    "strength": "1000mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Pyridoxine HCL, Niacinamide & D-panthenol 1000mcg with Benzyl Alcohol Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0154",
    "name": "Methylcobalamin, Pyridoxine HCL & Niacinamide Injection",
    "generic": "Methylcobalamin",
    "strength": "1500mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Pyridoxine HCL & Niacinamide Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0155",
    "name": "Thiamine HCL Injection",
    "generic": "Thiamine HCL",
    "strength": "100mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Thiamine HCL Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0156",
    "name": "Methylcobalamin, Vit. B6 & Nicotinamide Injection",
    "generic": "Methylcobalamin",
    "strength": "500mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Vit. B6 & Nicotinamide Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0157",
    "name": "Meropenam for Injection",
    "generic": "Meropenam",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Meropenam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0158",
    "name": "Ceftriaxone Sodium & Tazobactam for Injection 562.5 Mg",
    "generic": "Ceftriaxone Sodium & Tazobactam 562 5 Mg",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium & Tazobactam for Injection 562.5 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0159",
    "name": "Amoxycillin Sodium & Potassium Clavulanate Injection",
    "generic": "Amoxycillin Sodium & Potassium Clavulanate",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin Sodium & Potassium Clavulanate Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0160",
    "name": "Drotaverine HCL Injection",
    "generic": "Drotaverine HCL",
    "strength": "20mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Drotaverine HCL Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0161",
    "name": "Sodium Bicarbonate Injection. for I.V. Infusion Only) Sodium 5%w/v Bicarbonate",
    "generic": "Sodium Bicarbonate I V Infusion Only Sodium 5%w/v Bicarbonate",
    "strength": "5%",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Sodium Bicarbonate Injection. for I.V. Infusion Only) Sodium 5%w/v Bicarbonate — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0162",
    "name": "Arteether Injection",
    "generic": "Arteether",
    "strength": "150mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Arteether Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0163",
    "name": "Triamcinolone Acetonide Injection. for Intramuscular Use 40mg Only)",
    "generic": "Triamcinolone Acetonide Intramuscular Use 40mg Only",
    "strength": "40mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Orthopaedics",
    "pack": "As per regulatory specification",
    "desc": "Triamcinolone Acetonide Injection. for Intramuscular Use 40mg Only) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0164",
    "name": "Methylcobalamin, Pyridoxine HCL, Niacinamide & D-panthenol 1500mcg with Benzyl Alcohol Injection",
    "generic": "Methylcobalamin",
    "strength": "1500mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Pyridoxine HCL, Niacinamide & D-panthenol 1500mcg with Benzyl Alcohol Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0165",
    "name": "Methylcobalamin, Thiamine HCL, Pyridoxine HCL, Niacinamide & 1500mcg D-panthenol with Benzyl Alcohol Injection",
    "generic": "Methylcobalamin",
    "strength": "1500mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Thiamine HCL, Pyridoxine HCL, Niacinamide & 1500mcg D-panthenol with Benzyl Alcohol Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0166",
    "name": "Meropenam & Tazobactam for Injection",
    "generic": "Meropenam & Tazobactam",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Meropenam & Tazobactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0167",
    "name": "Cefotaxime Sodium for Injection",
    "generic": "Cefotaxime Sodium",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefotaxime Sodium for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0168",
    "name": "Meropenam for Injection",
    "generic": "Meropenam",
    "strength": "125mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Meropenam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0169",
    "name": "Cefepime & Tazobactam Injection 1.125 Gm",
    "generic": "Cefepime & Tazobactam 1 125 Gm",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefepime & Tazobactam Injection 1.125 Gm — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0170",
    "name": "Cefepime & Sulbactam Injection 1.500 Gm",
    "generic": "Cefepime & Sulbactam 1 500 Gm",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefepime & Sulbactam Injection 1.500 Gm — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0171",
    "name": "Imipenem & Cilastatin for Injection",
    "generic": "Imipenem & Cilastatin",
    "strength": "25mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Imipenem & Cilastatin for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0172",
    "name": "Ceftriaxone and Sulbactam for Injection 187.5 Mg",
    "generic": "Ceftriaxone and Sulbactam 187 5 Mg",
    "strength": "125mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone and Sulbactam for Injection 187.5 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0173",
    "name": "Methylcobalamin, Vit. B6, Nicotinamide & Calcium Pantothenate 1000mcg",
    "generic": "Methylcobalamin",
    "strength": "1000mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Vit. B6, Nicotinamide & Calcium Pantothenate 1000mcg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0174",
    "name": "Levetiracetam Concentrate for Infusion",
    "generic": "Levetiracetam Concentrate Infusion",
    "strength": "100mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Levetiracetam Concentrate for Infusion — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0175",
    "name": "Cefoperazone for Injection. 250 Mg",
    "generic": "Cefoperazone 250 Mg",
    "strength": "250mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefoperazone for Injection. 250 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0176",
    "name": "Thiamine HCL, Pyridoxine HCL, Cyanocobalamin, Riboflavin Sodium 100mg Phosphate, Niacinamide & D-panthenol Injection",
    "generic": "Thiamine HCL",
    "strength": "100mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Thiamine HCL, Pyridoxine HCL, Cyanocobalamin, Riboflavin Sodium 100mg Phosphate, Niacinamide & D-panthenol Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0177",
    "name": "Ceftriaxone Sodium for Injection. 1000 Mg",
    "generic": "Ceftriaxone Sodium 1000 Mg",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium for Injection. 1000 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0178",
    "name": "Ceftriaxone Sodium & Sulbactam for Injection 1500 Mg",
    "generic": "Ceftriaxone Sodium & Sulbactam 1500 Mg",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium & Sulbactam for Injection 1500 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0179",
    "name": "Piperacillin Sodium and Tazobactam for Injection. for IV Use 4000mg Only)",
    "generic": "Piperacillin Sodium and Tazobactam IV Use 4000mg Only",
    "strength": "4000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Piperacillin Sodium and Tazobactam for Injection. for IV Use 4000mg Only) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0180",
    "name": "Meropenam & Sulbactam for Injection",
    "generic": "Meropenam & Sulbactam",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Meropenam & Sulbactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0181",
    "name": "Amikacin Sulphate Injection. 250 Mg",
    "generic": "Amikacin Sulphate 250 Mg",
    "strength": "250mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amikacin Sulphate Injection. 250 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0182",
    "name": "Diclofenac Sodium Injection. 3 Ml",
    "generic": "Diclofenac Sodium 3 Ml",
    "strength": "25mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Diclofenac Sodium Injection. 3 Ml — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0183",
    "name": "Alpha Beta Arteether Injection",
    "generic": "Alpha Beta Arteether",
    "strength": "75mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Alpha Beta Arteether Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0184",
    "name": "Ranitidine HCL Injection",
    "generic": "Ranitidine HCL",
    "strength": "25mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Ranitidine HCL Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0185",
    "name": "Betamethasone Sodium Phosphate Injection",
    "generic": "Betamethasone Sodium Phosphate",
    "strength": "4mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Betamethasone Sodium Phosphate Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0186",
    "name": "Etofylline & Theophylline Injection",
    "generic": "Etofylline & Theophylline",
    "strength": "84.7mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Etofylline & Theophylline Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0187",
    "name": "Ondansetron HCL Injection. 4 Mg/2 Ml",
    "generic": "Ondansetron HCL 4 Mg/2 Ml",
    "strength": "2mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Ondansetron HCL Injection. 4 Mg/2 Ml — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0188",
    "name": "Vit. B12, Cholicalciferol, Calcium Glucono Lactobionate 50mcg",
    "generic": "Vit B12",
    "strength": "50mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Vit. B12, Cholicalciferol, Calcium Glucono Lactobionate 50mcg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0189",
    "name": "Cefoperazone for Injection. 1000 Mg",
    "generic": "Cefoperazone 1000 Mg",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefoperazone for Injection. 1000 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0190",
    "name": "Cefuroxime Injection. 750 Mg",
    "generic": "Cefuroxime 750 Mg",
    "strength": "750mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefuroxime Injection. 750 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0191",
    "name": "Sodium Valproate Injection",
    "generic": "Sodium Valproate",
    "strength": "100mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Sodium Valproate Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0192",
    "name": "Methylcobalamin, Pyridoxine HCL and Nicotinamide Injection",
    "generic": "Methylcobalamin",
    "strength": "1000mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Pyridoxine HCL and Nicotinamide Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0193",
    "name": "Piperacillin Sodium and Tazobactam for Injection 1.125 Gm",
    "generic": "Piperacillin Sodium and Tazobactam 1 125 Gm",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Piperacillin Sodium and Tazobactam for Injection 1.125 Gm — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0194",
    "name": "Sodium Valproate Injection",
    "generic": "Sodium Valproate",
    "strength": "200mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Sodium Valproate Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0195",
    "name": "Cefotaxime Sodium for Injection",
    "generic": "Cefotaxime Sodium",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefotaxime Sodium for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0196",
    "name": "Methylcobalamin, Nicotinamide & Folic Acid Injection",
    "generic": "Methylcobalamin",
    "strength": "1500mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Nicotinamide & Folic Acid Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0197",
    "name": "Folic Acid , B12 & Niacinamide Injection",
    "generic": "Folic Acid",
    "strength": "15mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Folic Acid , B12 & Niacinamide Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0198",
    "name": "Methylcobalamin, Pyridoxine HCL, Niacinamide and D-panthenol 1000mcg",
    "generic": "Methylcobalamin",
    "strength": "1000mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Pyridoxine HCL, Niacinamide and D-panthenol 1000mcg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0199",
    "name": "Ceftriaxone Sodium for Injection",
    "generic": "Ceftriaxone Sodium",
    "strength": "125mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone Sodium for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0200",
    "name": "Cefepime for Injection",
    "generic": "Cefepime",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefepime for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0201",
    "name": "Piperacillin & Tazobactam for Injection. 2.25 Gm",
    "generic": "Piperacillin & Tazobactam 2 25 Gm",
    "strength": "2gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Piperacillin & Tazobactam for Injection. 2.25 Gm — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0202",
    "name": "L-ornithine L-aspartate Infusion",
    "generic": "L-ornithine L-aspartate Infusion",
    "strength": "5mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "L-ornithine L-aspartate Infusion — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0203",
    "name": "Methylcobalamin, Pyridoxine, Niacinamide & Folic Acid Injection",
    "generic": "Methylcobalamin",
    "strength": "1500mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Pyridoxine, Niacinamide & Folic Acid Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0204",
    "name": "Iron Isomaltoside 1000 Solution for Injection/infusion",
    "generic": "Iron Isomaltoside 1000 /infusion",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Iron Isomaltoside 1000 Solution for Injection/infusion — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0205",
    "name": "Ceftriaxone for Injection",
    "generic": "Ceftriaxone",
    "strength": "250mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0206",
    "name": "Ampicillin Sodium for Injection",
    "generic": "Ampicillin Sodium",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ampicillin Sodium for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0207",
    "name": "Hydrocortisone Acetate Injection",
    "generic": "Hydrocortisone Acetate",
    "strength": "25mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Hydrocortisone Acetate Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0208",
    "name": "Vitamin C Injection (ascorbic Acid 500 Mg",
    "generic": "Vitamin C Ascorbic Acid 500 Mg",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Vitamin C Injection (ascorbic Acid 500 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0209",
    "name": "Vitamin B-complex Injection",
    "generic": "Vitamin B-complex",
    "strength": "100mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Vitamin B-complex Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0210",
    "name": "Triamcinolone Acetonide Injection",
    "generic": "Triamcinolone Acetonide",
    "strength": "10mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Orthopaedics",
    "pack": "As per regulatory specification",
    "desc": "Triamcinolone Acetonide Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0211",
    "name": "Ampicillin and Cloxacillin for Injection",
    "generic": "Ampicillin and Cloxacillin",
    "strength": "250mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ampicillin and Cloxacillin for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0212",
    "name": "Cefoperazone & Tazobactam for Injection",
    "generic": "Cefoperazone & Tazobactam",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefoperazone & Tazobactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0213",
    "name": "Meropenem for Injection",
    "generic": "Meropenem",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Meropenem for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0214",
    "name": "Ketorolac Tromethamine Injection",
    "generic": "Ketorolac Tromethamine",
    "strength": "30mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Ketorolac Tromethamine Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0215",
    "name": "Edaravone Injection",
    "generic": "Edaravone",
    "strength": "1.5mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Edaravone Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0216",
    "name": "Moxifloxacin Hydrochloride & Prednisolone Acetate",
    "generic": "Moxifloxacin Hydrochloride & Prednisolone Acetate",
    "strength": "0.05%w/v",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Moxifloxacin Hydrochloride & Prednisolone Acetate — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0217",
    "name": "Ampicillin & Cloxacillin for Injection. for Export Only ) 500mg Ampicillin Sodium",
    "generic": "Ampicillin & Cloxacillin Export Only 500mg Ampicillin Sodium",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ampicillin & Cloxacillin for Injection. for Export Only ) 500mg Ampicillin Sodium — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0218",
    "name": "Injection of Calcium Gluconate and Calcium Lactobionate",
    "generic": "Of Calcium Gluconate and Calcium Lactobionate",
    "strength": "50mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Injection of Calcium Gluconate and Calcium Lactobionate — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0219",
    "name": "Dexamethasone Injection. Dexamethasone Sodium Phosphate",
    "generic": "Dexamethasone Dexamethasone Sodium Phosphate",
    "strength": "4mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Dexamethasone Injection. Dexamethasone Sodium Phosphate — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0220",
    "name": "Gentamicin Sulphate Injection",
    "generic": "Gentamicin Sulphate",
    "strength": ".G",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Gentamicin Sulphate Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0221",
    "name": "Artemether Injection 80 Mg for Export Only )",
    "generic": "Artemether 80 Mg Export Only",
    "strength": "80mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Artemether Injection 80 Mg for Export Only ) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0222",
    "name": "Ceftriaxone for Injection",
    "generic": "Ceftriaxone",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftriaxone for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0223",
    "name": "Cefuroxime for Injection",
    "generic": "Cefuroxime",
    "strength": "750mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefuroxime for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0224",
    "name": "Ceftazidime for Injection",
    "generic": "Ceftazidime",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ceftazidime for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0225",
    "name": "Cefepime for Injection",
    "generic": "Cefepime",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefepime for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0226",
    "name": "Torsemide Injection",
    "generic": "Torsemide",
    "strength": "10mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Torsemide Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0227",
    "name": "Furosemide Injection",
    "generic": "Furosemide",
    "strength": "20mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Furosemide Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0228",
    "name": "Meropenem for Injection",
    "generic": "Meropenem",
    "strength": "1000mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Meropenem for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0229",
    "name": "Lincomycin Injection",
    "generic": "Lincomycin",
    "strength": "600mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Lincomycin Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0230",
    "name": "Omeprazole for Injection 40 Mg",
    "generic": "Omeprazole 40 Mg",
    "strength": "40mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Omeprazole for Injection 40 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0231",
    "name": "Amoxycillin & Sulbactam for Injection",
    "generic": "Amoxycillin & Sulbactam",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin & Sulbactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0232",
    "name": "Imipenem & Cilastatin for Injection",
    "generic": "Imipenem & Cilastatin",
    "strength": "500mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Imipenem & Cilastatin for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0233",
    "name": "Sterile Artesunate for Injection. the Combipack Contains:",
    "generic": "Sterile Artesunate the Combipack Contains:",
    "strength": "60mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Sterile Artesunate for Injection. the Combipack Contains: — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0234",
    "name": "Methylcobalamin, Niacinamide, Pyridoxine Hydrochloride Inj",
    "generic": "Methylcobalamin",
    "strength": "2500mcg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Niacinamide, Pyridoxine Hydrochloride Inj — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0235",
    "name": "Thiocolchicoside Injection",
    "generic": "Thiocolchicoside",
    "strength": "4mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Thiocolchicoside Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0236",
    "name": "Meropenem & Tazobactam for Injection",
    "generic": "Meropenem & Tazobactam",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Meropenem & Tazobactam for Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0237",
    "name": "Kanamycin Injection",
    "generic": "Kanamycin",
    "strength": "1gm",
    "form": "Injection",
    "category": "injectables",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Kanamycin Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0238",
    "name": "Cholecalciferol Injection",
    "generic": "Cholecalciferol",
    "strength": "000IU",
    "form": "Injection",
    "category": "injectables",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Cholecalciferol Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0239",
    "name": "Paracetamol Injection",
    "generic": "Paracetamol",
    "strength": "150mg",
    "form": "Injection",
    "category": "injectables",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol Injection — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0240",
    "name": "Solkat Sorafenib Tablet",
    "generic": "Solkat Sorafenib",
    "strength": "200 MG",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Solkat Sorafenib Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0241",
    "name": "Sitagliptin & Metformin Hydrochloride (SR) Tablets",
    "generic": "Sitagliptin & Metformin Hydrochloride SR",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Diabetology",
    "pack": "As per regulatory specification",
    "desc": "Sitagliptin & Metformin Hydrochloride (SR) Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0242",
    "name": "Doxylamine Succinate & Pyridoxine Hydrochloride Tablets",
    "generic": "Doxylamine Succinate & Pyridoxine Hydrochloride",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Doxylamine Succinate & Pyridoxine Hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0243",
    "name": "Ivermectin Tablets. 12mg",
    "generic": "Ivermectin 12mg",
    "strength": "12mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ivermectin Tablets. 12mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0244",
    "name": "Pyridoxine Hydrochloride & Meclizine Hydrochloride Tablets",
    "generic": "Pyridoxine Hydrochloride & Meclizine Hydrochloride",
    "strength": "25mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Pyridoxine Hydrochloride & Meclizine Hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0245",
    "name": "Loratadine Mouth Dissolving Tablets",
    "generic": "Loratadine Mouth Dissolving",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Loratadine Mouth Dissolving Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0246",
    "name": "Levocetirizine Dihydrochloride & Montelukast Sodium Tablets",
    "generic": "Levocetirizine Dihydrochloride & Montelukast Sodium",
    "strength": "2.5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Levocetirizine Dihydrochloride & Montelukast Sodium Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0247",
    "name": "Calcium Carbonate & Vitamin D3 Tablets",
    "generic": "Calcium Carbonate & Vitamin D3",
    "strength": "1250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Carbonate & Vitamin D3 Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0248",
    "name": "Betahistine Hydrochloride Tablets. 16mg",
    "generic": "Betahistine Hydrochloride 16mg",
    "strength": "16mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Betahistine Hydrochloride Tablets. 16mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0249",
    "name": "Betahistine Hydrochloride Tablets. 8mg",
    "generic": "Betahistine Hydrochloride 8mg",
    "strength": "8mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Betahistine Hydrochloride Tablets. 8mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0250",
    "name": "Sitagliptin & Metformin Tablets",
    "generic": "Sitagliptin & Metformin",
    "strength": "64.25mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Diabetology",
    "pack": "As per regulatory specification",
    "desc": "Sitagliptin & Metformin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0251",
    "name": "Levetiracetam Tablets 1000 Mg",
    "generic": "Levetiracetam 1000 Mg",
    "strength": "1000mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Levetiracetam Tablets 1000 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0252",
    "name": "Levetiracetam Tablets 500 Mg",
    "generic": "Levetiracetam 500 Mg",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Levetiracetam Tablets 500 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0253",
    "name": "Folic Acid, Methylcobalamin, Biotin, Calcium Pantothenate & 500mcg Vitamins Tablets",
    "generic": "Folic Acid",
    "strength": "500mcg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Folic Acid, Methylcobalamin, Biotin, Calcium Pantothenate & 500mcg Vitamins Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0254",
    "name": "Isoniazid Tablets",
    "generic": "Isoniazid",
    "strength": "300mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Isoniazid Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0255",
    "name": "Metoprolol Succinate Prolonged-release Tablets",
    "generic": "Metoprolol Succinate Prolonged-release",
    "strength": "47.50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Metoprolol Succinate Prolonged-release Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0256",
    "name": "Metoprolol Succinate Prolonged-release Tablets",
    "generic": "Metoprolol Succinate Prolonged-release",
    "strength": "23.75mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Metoprolol Succinate Prolonged-release Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0257",
    "name": "Calcium Citrate, Malate, Vitamine D3, Zinc Sulphate Monohydrate 1000mg & Magnesium Sulphate Tablets",
    "generic": "Calcium Citrate",
    "strength": "1000mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Citrate, Malate, Vitamine D3, Zinc Sulphate Monohydrate 1000mg & Magnesium Sulphate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0258",
    "name": "Calcium Citrate, Vitamine D3, Magnesium & Zinc Sulphate Tablets",
    "generic": "Calcium Citrate",
    "strength": "1000mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Citrate, Vitamine D3, Magnesium & Zinc Sulphate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0259",
    "name": "Serratiopeptidase Tablets",
    "generic": "Serratiopeptidase",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Serratiopeptidase Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0260",
    "name": "Mefenamic Acid and Dicyclomine Hydrochloride Tablets",
    "generic": "Mefenamic Acid and Dicyclomine Hydrochloride",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Mefenamic Acid and Dicyclomine Hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0261",
    "name": "Calcium Carbonate, Calcitriol, Methylcobalamin, Folic Acid & 200mg Vitamin B6 Tablets",
    "generic": "Calcium Carbonate",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Carbonate, Calcitriol, Methylcobalamin, Folic Acid & 200mg Vitamin B6 Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0262",
    "name": "Cefixime & Lactic Acid Bacillus Dispersible Tablets",
    "generic": "Cefixime & Lactic Acid Bacillus Dispersible",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime & Lactic Acid Bacillus Dispersible Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0263",
    "name": "Calcium Citrate, Carbonate, Calcitriol, Methylcobalamin, Folic 1250mg Acid & Vitamin B6 Tablets. for Therapeutic Use Only",
    "generic": "Calcium Citrate",
    "strength": "1250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Citrate, Carbonate, Calcitriol, Methylcobalamin, Folic 1250mg Acid & Vitamin B6 Tablets. for Therapeutic Use Only — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0264",
    "name": "Ferrous Ascorbate (SR), L-methylfolate, Methlcobalamin, Biotin, Cholecalciferol, Pyridoxal 5-phosphate & Multimineral Tablets. for Therapeutic Use)",
    "generic": "Ferrous Ascorbate SR",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate (SR), L-methylfolate, Methlcobalamin, Biotin, Cholecalciferol, Pyridoxal 5-phosphate & Multimineral Tablets. for Therapeutic Use) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0265",
    "name": "L-methylfolate Calcium, Methlcobalamin & Pyridoxal 1mg 5-phosphate Tablets",
    "generic": "L-methylfolate Calcium",
    "strength": "1mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "L-methylfolate Calcium, Methlcobalamin & Pyridoxal 1mg 5-phosphate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0266",
    "name": "Tadalafil 20 Mg Tablets",
    "generic": "Tadalafil 20 Mg",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Urology",
    "pack": "As per regulatory specification",
    "desc": "Tadalafil 20 Mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0267",
    "name": "Cetirizine Hydrochlorid 10 Mg Tablets",
    "generic": "Cetirizine Hydrochlorid 10 Mg",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Cetirizine Hydrochlorid 10 Mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0268",
    "name": "Atorvastatin20 Mg Tablets",
    "generic": "Atorvastatin20 Mg",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Atorvastatin20 Mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0269",
    "name": "Losartan Potassium 10 Mg Tablets",
    "generic": "Losartan Potassium 10 Mg",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Losartan Potassium 10 Mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0270",
    "name": "Losartan Potassium 50 Mg Tablets",
    "generic": "Losartan Potassium 50 Mg",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Losartan Potassium 50 Mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0271",
    "name": "Montelukast 10 Mg Tablets",
    "generic": "Montelukast 10 Mg",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Montelukast 10 Mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0272",
    "name": "Levofloxacin & Lactic Acid Bacillus Tablets",
    "generic": "Levofloxacin & Lactic Acid Bacillus",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Levofloxacin & Lactic Acid Bacillus Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0273",
    "name": "Gabapentin Tablets 300mg",
    "generic": "Gabapentin 300mg",
    "strength": "300mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Gabapentin Tablets 300mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0274",
    "name": "Duloxetine Tablets",
    "generic": "Duloxetine",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Duloxetine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0275",
    "name": "Ferrous Ascorbate & Folic Acid Tablets",
    "generic": "Ferrous Ascorbate & Folic Acid",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate & Folic Acid Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0276",
    "name": "Calcium Carbonate with Vitamin D3 & L-lysine Hydrochloride 1250mg Tablets",
    "generic": "Calcium Carbonate Vitamin D3 & L-lysine Hydrochloride 1250mg",
    "strength": "1250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Carbonate with Vitamin D3 & L-lysine Hydrochloride 1250mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0277",
    "name": "Ginkgo Biloba,piracetam & Vinpocetine Tablets",
    "generic": "Ginkgo Biloba",
    "strength": "60mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Ginkgo Biloba,piracetam & Vinpocetine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0278",
    "name": "Gabapentin & Nortriptyline Hydrochlorid Tablets",
    "generic": "Gabapentin & Nortriptyline Hydrochlorid",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Gabapentin & Nortriptyline Hydrochlorid Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0279",
    "name": "Fexofenadinehydrochloride & Montelukast Tablets",
    "generic": "Fexofenadinehydrochloride & Montelukast",
    "strength": "120mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Fexofenadinehydrochloride & Montelukast Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0280",
    "name": "Paracetamol, Phenylephrine Hydrochlorid,chlorpheniramine 500mg Maleate Tablets",
    "generic": "Paracetamol",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Phenylephrine Hydrochlorid,chlorpheniramine 500mg Maleate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0281",
    "name": "Fluconazole & Ivermectin Tablets",
    "generic": "Fluconazole & Ivermectin",
    "strength": "150mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Fluconazole & Ivermectin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0282",
    "name": "Ebastine Tablets. 10 Mg",
    "generic": "Ebastine 10 Mg",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Ebastine Tablets. 10 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0283",
    "name": "Epalrestat Sustained Release Tablets",
    "generic": "Epalrestat Sustained Release",
    "strength": "150mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Epalrestat Sustained Release Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0284",
    "name": "Naproxen & Domperidone Tablets",
    "generic": "Naproxen & Domperidone",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Naproxen & Domperidone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0285",
    "name": "Flunarizine & Propranolol Hydrochloride (SR) Tablets",
    "generic": "Flunarizine & Propranolol Hydrochloride SR",
    "strength": "400mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Flunarizine & Propranolol Hydrochloride (SR) Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0286",
    "name": "Levosulpiride Sustained Release Tablets",
    "generic": "Levosulpiride Sustained Release",
    "strength": "75mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Levosulpiride Sustained Release Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0287",
    "name": "Ferrous Ascorbate , Folic Acid & Cyanocobalamin Tablets",
    "generic": "Ferrous Ascorbate",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate , Folic Acid & Cyanocobalamin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0288",
    "name": "Ferrous Ascorbate , Cyanocobalamin, Folic Acid & Zinc Sulphate 100mg Tablets",
    "generic": "Ferrous Ascorbate",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate , Cyanocobalamin, Folic Acid & Zinc Sulphate 100mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0289",
    "name": "Gingo Biloba & Piracetam Tablets",
    "generic": "Gingo Biloba & Piracetam",
    "strength": "60mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Gingo Biloba & Piracetam Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0290",
    "name": "Ferrous Ascorbate ,folic Acid & Zinc Tablets",
    "generic": "Ferrous Ascorbate",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate ,folic Acid & Zinc Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0291",
    "name": "Ferrous Ascorbate ,l Methylfolate 100mg Calcium,pyridoxal-5-phosphate, Methylcobalamin Tablets",
    "generic": "Ferrous Ascorbate",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate ,l Methylfolate 100mg Calcium,pyridoxal-5-phosphate, Methylcobalamin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0292",
    "name": "Montelukast Sodium and Levocetirizine Hydrochloride Tablets",
    "generic": "Montelukast Sodium and Levocetirizine Hydrochloride",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Montelukast Sodium and Levocetirizine Hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0293",
    "name": "Drotaverine Hydrochloride & Paracetamol Tablets",
    "generic": "Drotaverine Hydrochloride & Paracetamol",
    "strength": "80mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Drotaverine Hydrochloride & Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0294",
    "name": "Linezolid Tablets",
    "generic": "Linezolid",
    "strength": "600mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Linezolid Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0295",
    "name": "Zopiclone Tablets. 7.5 Mg",
    "generic": "Zopiclone 7 5 Mg",
    "strength": "7.5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Psychiatry",
    "pack": "As per regulatory specification",
    "desc": "Zopiclone Tablets. 7.5 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0296",
    "name": "Camylofin Dihydrochloride & Diclofenac Potassium Tablets",
    "generic": "Camylofin Dihydrochloride & Diclofenac Potassium",
    "strength": "25mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Camylofin Dihydrochloride & Diclofenac Potassium Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0297",
    "name": "Ebastine & Montelukast Sodium Tablets",
    "generic": "Ebastine & Montelukast Sodium",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Ebastine & Montelukast Sodium Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0298",
    "name": "Acetylcysteine and Acebrophylline Tablets",
    "generic": "Acetylcysteine and Acebrophylline",
    "strength": "600mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Acetylcysteine and Acebrophylline Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0299",
    "name": "Mefanamic Acid & Dicyclomine Hydrochloride Tablets",
    "generic": "Mefanamic Acid & Dicyclomine Hydrochloride",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Mefanamic Acid & Dicyclomine Hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0300",
    "name": "Montelukast Sodium and Levocetirizine Hydrochloride Tablets",
    "generic": "Montelukast Sodium and Levocetirizine Hydrochloride",
    "strength": "5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Montelukast Sodium and Levocetirizine Hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0301",
    "name": "Rifaximin Tablets 400 Mg",
    "generic": "Rifaximin 400 Mg",
    "strength": "400mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Rifaximin Tablets 400 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0302",
    "name": "Citicoline Tablets. 500 Mg",
    "generic": "Citicoline 500 Mg",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Citicoline Tablets. 500 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0303",
    "name": "Aceclofenec 200 Mg S.R. Tablets",
    "generic": "Aceclofenec 200 Mg S R",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenec 200 Mg S.R. Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0304",
    "name": "Montelukast Sodium & Levocetirizine Di-hydrochloride Tablets",
    "generic": "Montelukast Sodium & Levocetirizine Di-hydrochloride",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Montelukast Sodium & Levocetirizine Di-hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0305",
    "name": "Paracetamol, Diclofenac Sodium & Caffeine Tablets",
    "generic": "Paracetamol",
    "strength": "325mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Diclofenac Sodium & Caffeine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0306",
    "name": "Montelukast Sodium & Levocetirizine Di-hydrochloride Tablets",
    "generic": "Montelukast Sodium & Levocetirizine Di-hydrochloride",
    "strength": "5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Montelukast Sodium & Levocetirizine Di-hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0307",
    "name": "Rifaximin Tablets 550 Mg",
    "generic": "Rifaximin 550 Mg",
    "strength": "550mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Rifaximin Tablets 550 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0308",
    "name": "Ciprofloxacin Tablets",
    "generic": "Ciprofloxacin",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ciprofloxacin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0309",
    "name": "Guaiphenesin,bromhexine HCL, Phenylephrine HCL, 100mg Chlorpheniramine Maleate & Paracetamol Tablets",
    "generic": "Guaiphenesin",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Guaiphenesin,bromhexine HCL, Phenylephrine HCL, 100mg Chlorpheniramine Maleate & Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0310",
    "name": "Metronidazole Tablets",
    "generic": "Metronidazole",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Metronidazole Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0311",
    "name": "Aceclofenac & Paracetamol Tablets",
    "generic": "Aceclofenac & Paracetamol",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenac & Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0312",
    "name": "Ibuprofen,paracetamol & Caffeine Tablets",
    "generic": "Ibuprofen",
    "strength": "400mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Ibuprofen,paracetamol & Caffeine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0313",
    "name": "Diclofenac Sodium, Paracetamol, Chlorpheniramine Maleate & Magnesium Trisilicate Tablet. Diclofenac Sodium (as Enteric Coated Granules)",
    "generic": "Diclofenac Sodium",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Diclofenac Sodium, Paracetamol, Chlorpheniramine Maleate & Magnesium Trisilicate Tablet. Diclofenac Sodium (as Enteric Coated Granules) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0314",
    "name": "Etoricoxib Tablets",
    "generic": "Etoricoxib",
    "strength": "60mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Etoricoxib Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0315",
    "name": "Methylcobalamin, L-methyl Folate & Pyridoxal 5-phosphate 1500mcg Tablets",
    "generic": "Methylcobalamin",
    "strength": "1500mcg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, L-methyl Folate & Pyridoxal 5-phosphate 1500mcg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0316",
    "name": "Trypsin, Bromelain, Rutoside Trihydrate Tablets",
    "generic": "Trypsin",
    "strength": "48mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Trypsin, Bromelain, Rutoside Trihydrate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0317",
    "name": "Azithromycin with Lactic Acid Bacillus Tablets",
    "generic": "Azithromycin Lactic Acid Bacillus",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Azithromycin with Lactic Acid Bacillus Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0318",
    "name": "Azithromycin with Lactic Acid Bacillus Tablets",
    "generic": "Azithromycin Lactic Acid Bacillus",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Azithromycin with Lactic Acid Bacillus Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0319",
    "name": "Divalproex Sodium Extended Release Tablet 500 Mg",
    "generic": "Divalproex Sodium Extended Release 500 Mg",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Divalproex Sodium Extended Release Tablet 500 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0320",
    "name": "Trimethoprim & Sulphamethoxazole Tablets",
    "generic": "Trimethoprim & Sulphamethoxazole",
    "strength": "160mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Trimethoprim & Sulphamethoxazole Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0321",
    "name": "Paracetamol Tablet",
    "generic": "Paracetamol",
    "strength": "325mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0322",
    "name": "Phenylephrine Hydrochloride & Chlorpheniramine Maleate 10mg Tablets",
    "generic": "Phenylephrine Hydrochloride & Chlorpheniramine Maleate 10mg",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Phenylephrine Hydrochloride & Chlorpheniramine Maleate 10mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0323",
    "name": "Rabeprazole Sodium Gastro Resistant Tablets",
    "generic": "Rabeprazole Sodium Gastro Resistant",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Rabeprazole Sodium Gastro Resistant Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0324",
    "name": "Drotaverine Hydrochloride and Mefenamic Acid Tablets",
    "generic": "Drotaverine Hydrochloride and Mefenamic Acid",
    "strength": "80mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Drotaverine Hydrochloride and Mefenamic Acid Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0325",
    "name": "Rabeprazole and Domperidone Gastro Resistant Tablets",
    "generic": "Rabeprazole and Domperidone Gastro Resistant",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Rabeprazole and Domperidone Gastro Resistant Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0326",
    "name": "Levocetirizine Di HCL Tablets",
    "generic": "Levocetirizine Di HCL",
    "strength": "5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Levocetirizine Di HCL Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0327",
    "name": "Ofloxacin Tablets",
    "generic": "Ofloxacin",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0328",
    "name": "Levofloxacin Tablets",
    "generic": "Levofloxacin",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Levofloxacin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0329",
    "name": "Cefdinir Tablets",
    "generic": "Cefdinir",
    "strength": "300mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefdinir Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0330",
    "name": "Divalproex Sodium Extended Release Tablet 250 Mg",
    "generic": "Divalproex Sodium Extended Release 250 Mg",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Divalproex Sodium Extended Release Tablet 250 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0331",
    "name": "Cabergoline Tablet. 0.5 Mg",
    "generic": "Cabergoline 0 5 Mg",
    "strength": "0.5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Cabergoline Tablet. 0.5 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0332",
    "name": "Cabergoline Tablet. 0.25 Mg",
    "generic": "Cabergoline 0 25 Mg",
    "strength": "0.25mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Cabergoline Tablet. 0.25 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0333",
    "name": "Montelukast & Acebrophylline Tablets",
    "generic": "Montelukast & Acebrophylline",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Montelukast & Acebrophylline Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0334",
    "name": "Cinnarizine & Domperidone Tablets",
    "generic": "Cinnarizine & Domperidone",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Cinnarizine & Domperidone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0335",
    "name": "Paracetamol, Diclofenac Potassium and Chlorzoxazone 50mg Tablets",
    "generic": "Paracetamol",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Diclofenac Potassium and Chlorzoxazone 50mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0336",
    "name": "Aceclofenac, Paracetamol and Chlorzoxazone Tablets",
    "generic": "Aceclofenac",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenac, Paracetamol and Chlorzoxazone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0337",
    "name": "Ondansetron HCL Mouth Dissolving Tablets",
    "generic": "Ondansetron HCL Mouth Dissolving",
    "strength": "4mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Ondansetron HCL Mouth Dissolving Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0338",
    "name": "Paracetamol Tablets",
    "generic": "Paracetamol",
    "strength": "650mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0339",
    "name": "Paracetamol, Phenylephrine, Caffeine and Cpm Tablets",
    "generic": "Paracetamol",
    "strength": "4mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Phenylephrine, Caffeine and Cpm Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0340",
    "name": "Ciprofloxacin Hydrochloride Tablets",
    "generic": "Ciprofloxacin Hydrochloride",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ciprofloxacin Hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0341",
    "name": "Diclofenac Potassium and Paracetamol Tablets",
    "generic": "Diclofenac Potassium and Paracetamol",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Diclofenac Potassium and Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0342",
    "name": "Paracetamol, Cetirizine and Phenylephrine Tablets",
    "generic": "Paracetamol",
    "strength": "325mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Cetirizine and Phenylephrine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0343",
    "name": "Vitamin B-complex Tablet",
    "generic": "Vitamin B-complex",
    "strength": "1.0mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Vitamin B-complex Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0344",
    "name": "Paracetamol, Cetirizine and Phenylephrine Tablets",
    "generic": "Paracetamol",
    "strength": "2.5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Cetirizine and Phenylephrine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0345",
    "name": "Aceclofenac and Tizanidine HCL Tablets. Each Film Coated Tablet 100mg Contain:",
    "generic": "Aceclofenac and Tizanidine HCL Each Film Coated 100mg Contain:",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenac and Tizanidine HCL Tablets. Each Film Coated Tablet 100mg Contain: — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0346",
    "name": "Levofloxacin Hemihydrate Tablets",
    "generic": "Levofloxacin Hemihydrate",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Levofloxacin Hemihydrate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0347",
    "name": "Levofloxacin Hemihydrate Tablets",
    "generic": "Levofloxacin Hemihydrate",
    "strength": "750mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Levofloxacin Hemihydrate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0348",
    "name": "Ofloxacin Tablets",
    "generic": "Ofloxacin",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0349",
    "name": "Albendazole and Ivermectin Tablets",
    "generic": "Albendazole and Ivermectin",
    "strength": "400mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Albendazole and Ivermectin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0350",
    "name": "Fluconazole Tablets",
    "generic": "Fluconazole",
    "strength": "150mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Fluconazole Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0351",
    "name": "Atorvastatin Calcium Tablets",
    "generic": "Atorvastatin Calcium",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Atorvastatin Calcium Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0352",
    "name": "Losartan Potassium and Hydrochlorthiazide Tablets",
    "generic": "Losartan Potassium and Hydrochlorthiazide",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Losartan Potassium and Hydrochlorthiazide Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0353",
    "name": "Nimesulide and Dicyclomine Hydrochloride Tablets",
    "generic": "Nimesulide and Dicyclomine Hydrochloride",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Nimesulide and Dicyclomine Hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0354",
    "name": "Nimesulide Mouth Dissolving Tablets",
    "generic": "Nimesulide Mouth Dissolving",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Nimesulide Mouth Dissolving Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0355",
    "name": "Tramadol Hydrochloride and Paracetamol Tablets",
    "generic": "Tramadol Hydrochloride and Paracetamol",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Tramadol Hydrochloride and Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0356",
    "name": "Pantoprazole Sodium Sesquihydrate and Domperidone Tablets",
    "generic": "Pantoprazole Sodium Sesquihydrate and Domperidone",
    "strength": "40mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Pantoprazole Sodium Sesquihydrate and Domperidone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0357",
    "name": "Levocetirizine Dihydrochloride and Ambroxol Tablets",
    "generic": "Levocetirizine Dihydrochloride and Ambroxol",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Levocetirizine Dihydrochloride and Ambroxol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0358",
    "name": "Levocetirizine Dihydrochloride, Phenylephrine and 5mg Paracetamol Tablets",
    "generic": "Levocetirizine Dihydrochloride",
    "strength": "5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Levocetirizine Dihydrochloride, Phenylephrine and 5mg Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0359",
    "name": "Domperidone Mouth Dispersible Tablets",
    "generic": "Domperidone Mouth Dispersible",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Domperidone Mouth Dispersible Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0360",
    "name": "Aceclofenac and Thiocolchicoside Tablets",
    "generic": "Aceclofenac and Thiocolchicoside",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenac and Thiocolchicoside Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0361",
    "name": "Dicyclomine Hydrochloride and Mefenamic Acid Tablets",
    "generic": "Dicyclomine Hydrochloride and Mefenamic Acid",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Dicyclomine Hydrochloride and Mefenamic Acid Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0362",
    "name": "Aceclofenac and Drotaverine Tablets",
    "generic": "Aceclofenac and Drotaverine",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenac and Drotaverine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0363",
    "name": "Pantoprazole Sodium Gastro Resistant Tablets",
    "generic": "Pantoprazole Sodium Gastro Resistant",
    "strength": "40mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Pantoprazole Sodium Gastro Resistant Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0364",
    "name": "Paracetamol Tablets",
    "generic": "Paracetamol",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0365",
    "name": "Phenylephrine HCL , Chlorpheniramine Maleate, Paracetamol 10mg and Caffeine Tablets",
    "generic": "Phenylephrine HCL",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Phenylephrine HCL , Chlorpheniramine Maleate, Paracetamol 10mg and Caffeine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0366",
    "name": "Montelukast Sodium and Fexofenadine Hydrochloride Tablets",
    "generic": "Montelukast Sodium and Fexofenadine Hydrochloride",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Montelukast Sodium and Fexofenadine Hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0367",
    "name": "Amlodipine Besylate and Atenolol Tablets",
    "generic": "Amlodipine Besylate and Atenolol",
    "strength": "5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Amlodipine Besylate and Atenolol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0368",
    "name": "Amlodipine Besylate Tablets",
    "generic": "Amlodipine Besylate",
    "strength": "5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Amlodipine Besylate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0369",
    "name": "Etoricoxib Tablets",
    "generic": "Etoricoxib",
    "strength": "120mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Etoricoxib Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0370",
    "name": "Paracetamol, Cetirizine Di HCL, Phenylephrine HCL and Caffeine 325mg Anhydrous Tablets",
    "generic": "Paracetamol",
    "strength": "325mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Cetirizine Di HCL, Phenylephrine HCL and Caffeine 325mg Anhydrous Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0371",
    "name": "Ferrous Ascorbate, Folic Acid , Cyanocobalamin, 100mg Cholicalciferol and Zinc Sulphate Tablets",
    "generic": "Ferrous Ascorbate",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate, Folic Acid , Cyanocobalamin, 100mg Cholicalciferol and Zinc Sulphate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0372",
    "name": "Terbinafine Tablets",
    "generic": "Terbinafine",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Terbinafine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0373",
    "name": "Mefenamic Acid and Drotaverine HCL Tablets",
    "generic": "Mefenamic Acid and Drotaverine HCL",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Mefenamic Acid and Drotaverine HCL Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0374",
    "name": "Telmisartan Tablets",
    "generic": "Telmisartan",
    "strength": "40mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Telmisartan Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0375",
    "name": "Telmisartan and Amilodipine Besylate Tablets",
    "generic": "Telmisartan and Amilodipine Besylate",
    "strength": "40mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Telmisartan and Amilodipine Besylate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0376",
    "name": "Telmisartan and Chlorthalidone Tablets",
    "generic": "Telmisartan and Chlorthalidone",
    "strength": "40mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Telmisartan and Chlorthalidone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0377",
    "name": "Tramadol Hydrochloride, Paracetamol and Chlorzoxazone 50mg Tablets",
    "generic": "Tramadol Hydrochloride",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Tramadol Hydrochloride, Paracetamol and Chlorzoxazone 50mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0378",
    "name": "Paracetamol, Levocetirizine Di HCL, Phenylephrine HCL and 5mg Caffeine Anhydrous Tablets",
    "generic": "Paracetamol",
    "strength": "5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Levocetirizine Di HCL, Phenylephrine HCL and 5mg Caffeine Anhydrous Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0379",
    "name": "Paracetamol and Dicyclomine HCL Tablets",
    "generic": "Paracetamol and Dicyclomine HCL",
    "strength": "325mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol and Dicyclomine HCL Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0380",
    "name": "Telmisartan & Chlorthalidone Tablets",
    "generic": "Telmisartan & Chlorthalidone",
    "strength": "80mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Telmisartan & Chlorthalidone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0381",
    "name": "Telmisartan & Chlorthalidone Tablets",
    "generic": "Telmisartan & Chlorthalidone",
    "strength": "40mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Telmisartan & Chlorthalidone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0382",
    "name": "Tramadol Hydrochloride and Paracetamol Tablets",
    "generic": "Tramadol Hydrochloride and Paracetamol",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Tramadol Hydrochloride and Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0383",
    "name": "Montelukast Sodium & Levocetirizine Dihydrochloride Mouth 10mg Dissolving Tablets",
    "generic": "Montelukast Sodium & Levocetirizine Dihydrochloride Mouth 10mg Dissolving",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Montelukast Sodium & Levocetirizine Dihydrochloride Mouth 10mg Dissolving Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0384",
    "name": "Levocetirizine Dihcl Mouth Dissolving Tablets",
    "generic": "Levocetirizine Dihcl Mouth Dissolving",
    "strength": "5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Levocetirizine Dihcl Mouth Dissolving Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0385",
    "name": "Cefixime Dispersible Tablets",
    "generic": "Cefixime Dispersible",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime Dispersible Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0386",
    "name": "Deflazacort Tablets",
    "generic": "Deflazacort",
    "strength": "6mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Urology",
    "pack": "As per regulatory specification",
    "desc": "Deflazacort Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0387",
    "name": "Diclofenac Potassium,paracetamol and Serratiopeptidase 50mg Tablets",
    "generic": "Diclofenac Potassium",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Diclofenac Potassium,paracetamol and Serratiopeptidase 50mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0388",
    "name": "Roxithromycin Tablets",
    "generic": "Roxithromycin",
    "strength": "150mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Roxithromycin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0389",
    "name": "Cefuroxime Axetil Tablets",
    "generic": "Cefuroxime Axetil",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefuroxime Axetil Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0390",
    "name": "Azithromycin Dispersible Tablets 100 Mg",
    "generic": "Azithromycin Dispersible 100 Mg",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Azithromycin Dispersible Tablets 100 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0391",
    "name": "Cefixime and Dicloxacillin Tablets",
    "generic": "Cefixime and Dicloxacillin",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime and Dicloxacillin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0392",
    "name": "Vitamin D3 Chewable Tablets",
    "generic": "Vitamin D3 Chewable",
    "strength": "60000UI",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Vitamin D3 Chewable Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0393",
    "name": "Artemether and Lumefantrine Tablets",
    "generic": "Artemether and Lumefantrine",
    "strength": "80mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Artemether and Lumefantrine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0394",
    "name": "Diclofenac Sodium and Serratiopeptidase Tablets",
    "generic": "Diclofenac Sodium and Serratiopeptidase",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Diclofenac Sodium and Serratiopeptidase Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0395",
    "name": "Cefixime and Azithromycin Tablets",
    "generic": "Cefixime and Azithromycin",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime and Azithromycin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0396",
    "name": "Diclofenac Potassium and Serratiopeptidase Tablets",
    "generic": "Diclofenac Potassium and Serratiopeptidase",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Diclofenac Potassium and Serratiopeptidase Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0397",
    "name": "Cefixime ,ofloxacin and Lactic Acid Bacillus Tablets",
    "generic": "Cefixime",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime ,ofloxacin and Lactic Acid Bacillus Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0398",
    "name": "Ampicillin and Dicloxacillin Tablets",
    "generic": "Ampicillin and Dicloxacillin",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ampicillin and Dicloxacillin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0399",
    "name": "Aceclofenac, Paracetamol and Serratiopeptidase Tablets",
    "generic": "Aceclofenac",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenac, Paracetamol and Serratiopeptidase Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0400",
    "name": "Amoxycillin Dispersible Tablets",
    "generic": "Amoxycillin Dispersible",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin Dispersible Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0401",
    "name": "Cefpodoxime Dispersible Tablets 200 Mg",
    "generic": "Cefpodoxime Dispersible 200 Mg",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefpodoxime Dispersible Tablets 200 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0402",
    "name": "Calcium Carbonate and Alfacalcidol with Beta Carotene 0.25mg Tablets",
    "generic": "Calcium Carbonate and Alfacalcidol Beta Carotene 0 25mg",
    "strength": "0.25mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Carbonate and Alfacalcidol with Beta Carotene 0.25mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0403",
    "name": "Calcium Citrate, Calcitriol, Magnesium Hydroxide and Zinc 1200mg Tablets",
    "generic": "Calcium Citrate",
    "strength": "1200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Calcium Citrate, Calcitriol, Magnesium Hydroxide and Zinc 1200mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0404",
    "name": "Calcium Citrate, Magnesium Hydroxide, Vit D3 and Zinc Tablets",
    "generic": "Calcium Citrate",
    "strength": "1000mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Calcium Citrate, Magnesium Hydroxide, Vit D3 and Zinc Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0405",
    "name": "Ferrous Ascorbate, Folic Acid, Cyanocobalamin, Vit D3 and Zinc 100mg Tablets",
    "generic": "Ferrous Ascorbate",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate, Folic Acid, Cyanocobalamin, Vit D3 and Zinc 100mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0406",
    "name": "Cefuroxime Axetil Tablets. 250 Mg",
    "generic": "Cefuroxime Axetil 250 Mg",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefuroxime Axetil Tablets. 250 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0407",
    "name": "Calcium Carbonate, Vit D3, Magnesium, L-lysine and Zinc Tablets",
    "generic": "Calcium Carbonate",
    "strength": "1250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Carbonate, Vit D3, Magnesium, L-lysine and Zinc Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0408",
    "name": "Cefixime Trihydrate with Lactic Acid Bacillus Tablets",
    "generic": "Cefixime Trihydrate Lactic Acid Bacillus",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime Trihydrate with Lactic Acid Bacillus Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0409",
    "name": "Theophylline Tablets 200 Mg",
    "generic": "Theophylline 200 Mg",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Theophylline Tablets 200 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0410",
    "name": "Ofloxacin and Ornidazole Tablets",
    "generic": "Ofloxacin and Ornidazole",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin and Ornidazole Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0411",
    "name": "Nimesulide and Paracetamol Tablets",
    "generic": "Nimesulide and Paracetamol",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Nimesulide and Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0412",
    "name": "Aceclofenac and Paracetamol Tablets",
    "generic": "Aceclofenac and Paracetamol",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenac and Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0413",
    "name": "Cefixime Trihydrate Tablets",
    "generic": "Cefixime Trihydrate",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime Trihydrate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0414",
    "name": "Cefpodoxime Proxetil Tablets",
    "generic": "Cefpodoxime Proxetil",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefpodoxime Proxetil Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0415",
    "name": "Cefixime Trihydrate Dispersible Tablets",
    "generic": "Cefixime Trihydrate Dispersible",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime Trihydrate Dispersible Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0416",
    "name": "Telmisartan & Chlorthalidone Tablets",
    "generic": "Telmisartan & Chlorthalidone",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Telmisartan & Chlorthalidone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0417",
    "name": "Diclofenac Sodium and Paracetamol Tablets. Each Uncoated 50mg Tablet Contain: Diclofenac Sodium",
    "generic": "Diclofenac Sodium and Paracetamol Each Uncoated 50mg Contain: Diclofenac Sodium",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Diclofenac Sodium and Paracetamol Tablets. Each Uncoated 50mg Tablet Contain: Diclofenac Sodium — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0418",
    "name": "Tramadol Hydrochloride and Paracetamol Tablets",
    "generic": "Tramadol Hydrochloride and Paracetamol",
    "strength": "37.5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Tramadol Hydrochloride and Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0419",
    "name": "Montelukast and Levocetirizine Tablets",
    "generic": "Montelukast and Levocetirizine",
    "strength": "2.5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Montelukast and Levocetirizine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0420",
    "name": "Cefixime Tablets",
    "generic": "Cefixime",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0421",
    "name": "Multivitamin, Multimineral & Antioxidants Tablets with Ginseng",
    "generic": "Multivitamin",
    "strength": "42.5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Multivitamin, Multimineral & Antioxidants Tablets with Ginseng — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0422",
    "name": "Cefpodoxime Dispersible Tablets 50 Mg",
    "generic": "Cefpodoxime Dispersible 50 Mg",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefpodoxime Dispersible Tablets 50 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0423",
    "name": "Betamethasone Tablet",
    "generic": "Betamethasone",
    "strength": "0.5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Betamethasone Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0424",
    "name": "Cefuroxime Axetil & Lactic Acid Bacillus Tablets",
    "generic": "Cefuroxime Axetil & Lactic Acid Bacillus",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefuroxime Axetil & Lactic Acid Bacillus Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0425",
    "name": "Pregabalin with Methylcobalamin Tablets",
    "generic": "Pregabalin Methylcobalamin",
    "strength": "75mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Pregabalin with Methylcobalamin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0426",
    "name": "Doxylamine Succinate, Pyridoxine HCL and Folic Acid Tablets",
    "generic": "Doxylamine Succinate",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Doxylamine Succinate, Pyridoxine HCL and Folic Acid Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0427",
    "name": "Trimethoprim Tablets 200 Mg",
    "generic": "Trimethoprim 200 Mg",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Trimethoprim Tablets 200 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0428",
    "name": "Ampicillin and Dicloxacillin Dispersible Tablets",
    "generic": "Ampicillin and Dicloxacillin Dispersible",
    "strength": "125mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ampicillin and Dicloxacillin Dispersible Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0429",
    "name": "Cefpodoxime and Ofloxacin Tablets",
    "generic": "Cefpodoxime and Ofloxacin",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefpodoxime and Ofloxacin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0430",
    "name": "Cefpodoxime and Dicloxacillin Tablets",
    "generic": "Cefpodoxime and Dicloxacillin",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefpodoxime and Dicloxacillin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0431",
    "name": "Cefpodoxime Dispersible Tablets 100 Mg",
    "generic": "Cefpodoxime Dispersible 100 Mg",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefpodoxime Dispersible Tablets 100 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0432",
    "name": "Chlorthalidone Tablets",
    "generic": "Chlorthalidone",
    "strength": "12.5mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Chlorthalidone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0433",
    "name": "Chlorthalidone Tablets",
    "generic": "Chlorthalidone",
    "strength": "6.25mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Chlorthalidone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0434",
    "name": "Mefenamic Acid & Paracetamol Tablets",
    "generic": "Mefenamic Acid & Paracetamol",
    "strength": "325mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Mefenamic Acid & Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0435",
    "name": "Albendazole Tablets",
    "generic": "Albendazole",
    "strength": "400mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Albendazole Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0436",
    "name": "Calcium Carbonate , Calcitriol and Zinc Tablets",
    "generic": "Calcium Carbonate",
    "strength": "0.25mcg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Carbonate , Calcitriol and Zinc Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0437",
    "name": "Ferrous Ascorbate ,folic Acid , Vit B12 with Zinc Tablets",
    "generic": "Ferrous Ascorbate",
    "strength": "30mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate ,folic Acid , Vit B12 with Zinc Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0438",
    "name": "Cefixime & Azithromycin Tablets with Lactic Acid Bacillus",
    "generic": "Cefixime & Azithromycin Lactic Acid Bacillus",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime & Azithromycin Tablets with Lactic Acid Bacillus — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0439",
    "name": "Alpha Lipoic Acid , Pyridoxine HCL , Methylcobalamin, Folic Acid & 100mg Vitamin D3 Tablets",
    "generic": "Alpha Lipoic Acid",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Alpha Lipoic Acid , Pyridoxine HCL , Methylcobalamin, Folic Acid & 100mg Vitamin D3 Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0440",
    "name": "Amoxycillin and Dicloxacillin Dispersible Tablets",
    "generic": "Amoxycillin and Dicloxacillin Dispersible",
    "strength": "125mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin and Dicloxacillin Dispersible Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0441",
    "name": "Calcium Citrate Maleate, Calcitriol, Magnesium Hydroxide and 1000mg Zinc Tablets",
    "generic": "Calcium Citrate Maleate",
    "strength": "1000mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Calcium Citrate Maleate, Calcitriol, Magnesium Hydroxide and 1000mg Zinc Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0442",
    "name": "Aceclofenac and Drotaverine HCL Tablet",
    "generic": "Aceclofenac and Drotaverine HCL",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenac and Drotaverine HCL Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0443",
    "name": "Multivitamin, Multimineral & Antioxidant Suspension with 6% Lycopene",
    "generic": "Multivitamin",
    "strength": "As specified",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Multivitamin, Multimineral & Antioxidant Suspension with 6% Lycopene — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0444",
    "name": "Alpha Lipoic Acid, Pyridoxine HCL, Methylcobalamin, Folic Acid & 100mg Vitamin D3tablets",
    "generic": "Alpha Lipoic Acid",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Alpha Lipoic Acid, Pyridoxine HCL, Methylcobalamin, Folic Acid & 100mg Vitamin D3tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0445",
    "name": "Mecobalamin, Alpha Lipoic Acid, Vit B6, Folic Acid, Zinc Sulphate, 1500mcg Selenium, Chromium Picolinate, Biotin and Inositol Tablet",
    "generic": "Mecobalamin",
    "strength": "1500mcg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Mecobalamin, Alpha Lipoic Acid, Vit B6, Folic Acid, Zinc Sulphate, 1500mcg Selenium, Chromium Picolinate, Biotin and Inositol Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0446",
    "name": "Cefpodoxime Proxetil Dispersible Tablets 100 Mg",
    "generic": "Cefpodoxime Proxetil Dispersible 100 Mg",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefpodoxime Proxetil Dispersible Tablets 100 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0447",
    "name": "Calcium Carbonate, Alfacalcidol and Zinc Tablets",
    "generic": "Calcium Carbonate",
    "strength": "0.25mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Carbonate, Alfacalcidol and Zinc Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0448",
    "name": "Secnidazole Tablets ( for Export Only )",
    "generic": "Secnidazole Export Only",
    "strength": "1000mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Secnidazole Tablets ( for Export Only ) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0449",
    "name": "Calcium Carbonate and Vitamin D3 Tablets",
    "generic": "Calcium Carbonate and Vitamin D3",
    "strength": "1.25gm",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Carbonate and Vitamin D3 Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0450",
    "name": "Cefixime & Ofloxacin Tablets",
    "generic": "Cefixime & Ofloxacin",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime & Ofloxacin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0451",
    "name": "Zinc Sulphate Tablet",
    "generic": "Zinc Sulphate",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Zinc Sulphate Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0452",
    "name": "Mecobalamin, Vit. B1,b6, Calcium Pantothenate & Nicotinamide 500mcg",
    "generic": "Mecobalamin",
    "strength": "500mcg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Mecobalamin, Vit. B1,b6, Calcium Pantothenate & Nicotinamide 500mcg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0453",
    "name": "Piracetam & Citicoline Tablets",
    "generic": "Piracetam & Citicoline",
    "strength": "800mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Piracetam & Citicoline Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0454",
    "name": "Doxofylline MR Tablets",
    "generic": "Doxofylline MR",
    "strength": "650mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Doxofylline MR Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0455",
    "name": "Doxofylline and Ambroxol Tablets",
    "generic": "Doxofylline and Ambroxol",
    "strength": "400mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Doxofylline and Ambroxol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0456",
    "name": "Doxofylline (SR) and Montelukast Tablets",
    "generic": "Doxofylline SR and Montelukast",
    "strength": "400/800mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Doxofylline (SR) and Montelukast Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0457",
    "name": "Doxofylline and Terbutalin Tablets",
    "generic": "Doxofylline and Terbutalin",
    "strength": "400mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Doxofylline and Terbutalin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0458",
    "name": "Doxofylline and Ambroxol Tablets",
    "generic": "Doxofylline and Ambroxol",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Doxofylline and Ambroxol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0459",
    "name": "Etoricoxib & Thiocolchicoside Tablets",
    "generic": "Etoricoxib & Thiocolchicoside",
    "strength": "120mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Etoricoxib & Thiocolchicoside Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0460",
    "name": "Etoricoxib & Paracetamol Tablets",
    "generic": "Etoricoxib & Paracetamol",
    "strength": "60mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Etoricoxib & Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0461",
    "name": "Talmisartan & Metoprolol Succinate (prolonged-release) 40mg Tablets",
    "generic": "Talmisartan & Metoprolol Succinate Prolonged-release 40mg",
    "strength": "40mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Cardiovascular",
    "pack": "As per regulatory specification",
    "desc": "Talmisartan & Metoprolol Succinate (prolonged-release) 40mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0462",
    "name": "Aceclofenac S.R. Tablets",
    "generic": "Aceclofenac S R",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenac S.R. Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0463",
    "name": "Levosulpiride 25 Tablets",
    "generic": "Levosulpiride 25",
    "strength": "25mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Levosulpiride 25 Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0464",
    "name": "Etoricoxib & Thiocolchicoside Tablets",
    "generic": "Etoricoxib & Thiocolchicoside",
    "strength": "60mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Etoricoxib & Thiocolchicoside Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0465",
    "name": "Etoricoxib & Serratiopeptidase Tablet",
    "generic": "Etoricoxib & Serratiopeptidase",
    "strength": "60mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Etoricoxib & Serratiopeptidase Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0466",
    "name": "Ursodeoxycholic Acid Tablets",
    "generic": "Ursodeoxycholic Acid",
    "strength": "300mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Ursodeoxycholic Acid Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0467",
    "name": "Aceclofenac & Paracetamol Tablets",
    "generic": "Aceclofenac & Paracetamol",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenac & Paracetamol Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0468",
    "name": "Pregabalin & Nortriptyline Tablets",
    "generic": "Pregabalin & Nortriptyline",
    "strength": "75mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Pregabalin & Nortriptyline Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0469",
    "name": "Pregabalin & Nortriptyline Tablets",
    "generic": "Pregabalin & Nortriptyline",
    "strength": "70mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Pregabalin & Nortriptyline Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0470",
    "name": "Cinnarizine & Domperidone Tablets",
    "generic": "Cinnarizine & Domperidone",
    "strength": "25mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Cinnarizine & Domperidone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0471",
    "name": "Eperisone HCL Sustained Release Capsules",
    "generic": "Eperisone HCL Sustained Release",
    "strength": "150mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Eperisone HCL Sustained Release Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0472",
    "name": "Memantine Hydrochloride & Donepezil Hydrochloride Tablets",
    "generic": "Memantine Hydrochloride & Donepezil Hydrochloride",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Memantine Hydrochloride & Donepezil Hydrochloride Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0473",
    "name": "Aceclofenac, Paracetamol & Eperisone Tablets",
    "generic": "Aceclofenac",
    "strength": "100mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Aceclofenac, Paracetamol & Eperisone Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0474",
    "name": "Albendazole & Ivermectin Tablets",
    "generic": "Albendazole & Ivermectin",
    "strength": "400mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Albendazole & Ivermectin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0475",
    "name": "Dextromethorphen Hbr, Chlorpheniramine Maleate & 10mg Phenylephrine HCL Tablets",
    "generic": "Dextromethorphen Hbr",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Dextromethorphen Hbr, Chlorpheniramine Maleate & 10mg Phenylephrine HCL Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0476",
    "name": "Alpha Glycerylphosphorylcholine & Piracetam Tablet",
    "generic": "Alpha Glycerylphosphorylcholine & Piracetam",
    "strength": "250mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Alpha Glycerylphosphorylcholine & Piracetam Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0477",
    "name": "Cerebroprotein Hydrolysate Tablets",
    "generic": "Cerebroprotein Hydrolysate",
    "strength": "90mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Oncology",
    "pack": "As per regulatory specification",
    "desc": "Cerebroprotein Hydrolysate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0478",
    "name": "Fexofenadine Hydrochloride 120 Mg Tablets",
    "generic": "Fexofenadine Hydrochloride 120 Mg",
    "strength": "120mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Fexofenadine Hydrochloride 120 Mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0479",
    "name": "Fexofenadine Hydrochloride 180 Mg Tablets",
    "generic": "Fexofenadine Hydrochloride 180 Mg",
    "strength": "180mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Fexofenadine Hydrochloride 180 Mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0480",
    "name": "Paracetamol, Phenylephrine HCL, Cetirizine Di-hydrochloride 500mg Tablets",
    "generic": "Paracetamol",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Phenylephrine HCL, Cetirizine Di-hydrochloride 500mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0481",
    "name": "Diclofenac Sodium Dispersible Tablets",
    "generic": "Diclofenac Sodium Dispersible",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Diclofenac Sodium Dispersible Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0482",
    "name": "Azithromycin 500 Mg Tablet",
    "generic": "Azithromycin 500 Mg",
    "strength": "500mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Azithromycin 500 Mg Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0483",
    "name": "Cefixime Trihydrate Tablets",
    "generic": "Cefixime Trihydrate",
    "strength": "400mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime Trihydrate Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0484",
    "name": "Ketorolac Tromethamine Dispersible Tablets 10 Mg",
    "generic": "Ketorolac Tromethamine Dispersible 10 Mg",
    "strength": "10mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Ketorolac Tromethamine Dispersible Tablets 10 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0485",
    "name": "Betahistine Hydrochloride Dispersible Tablets 16 Mg",
    "generic": "Betahistine Hydrochloride Dispersible 16 Mg",
    "strength": "16mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Betahistine Hydrochloride Dispersible Tablets 16 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0486",
    "name": "Cefpodoxime Proxetil & Ofloxacin Tablet",
    "generic": "Cefpodoxime Proxetil & Ofloxacin",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefpodoxime Proxetil & Ofloxacin Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0487",
    "name": "Glimepiride & Metformin Hydrochloride Prolonged Release 1mg Tablets",
    "generic": "Glimepiride & Metformin Hydrochloride Prolonged Release 1mg",
    "strength": "1mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Diabetology",
    "pack": "As per regulatory specification",
    "desc": "Glimepiride & Metformin Hydrochloride Prolonged Release 1mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0488",
    "name": "Glimepiride & Metformin Hydrochloride Prolonged Release 2mg Tablets",
    "generic": "Glimepiride & Metformin Hydrochloride Prolonged Release 2mg",
    "strength": "2mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Diabetology",
    "pack": "As per regulatory specification",
    "desc": "Glimepiride & Metformin Hydrochloride Prolonged Release 2mg Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0489",
    "name": "Faropenem ER Tablets 300 Mg",
    "generic": "Faropenem ER 300 Mg",
    "strength": "300mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Faropenem ER Tablets 300 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0490",
    "name": "Faropenem Tablets 200 Mg",
    "generic": "Faropenem 200 Mg",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Faropenem Tablets 200 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0491",
    "name": "Teneligliptin Hydrobromide Hydrate & Metformin 20mg Hydrochloride (ER) Tablets",
    "generic": "Teneligliptin Hydrobromide Hydrate & Metformin 20mg Hydrochloride ER",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Diabetology",
    "pack": "As per regulatory specification",
    "desc": "Teneligliptin Hydrobromide Hydrate & Metformin 20mg Hydrochloride (ER) Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0492",
    "name": "Calcium Orotate Tablet 740 Mg",
    "generic": "Calcium Orotate 740 Mg",
    "strength": "740mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Orotate Tablet 740 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0493",
    "name": "Tizanidine Tablets",
    "generic": "Tizanidine",
    "strength": "2mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Tizanidine Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0494",
    "name": "Teneligliptin Tablets 20 Mg",
    "generic": "Teneligliptin 20 Mg",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Diabetology",
    "pack": "As per regulatory specification",
    "desc": "Teneligliptin Tablets 20 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0495",
    "name": "Vildagliptin Tablets",
    "generic": "Vildagliptin",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Diabetology",
    "pack": "As per regulatory specification",
    "desc": "Vildagliptin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0496",
    "name": "Vildagliptin & Metformin HCL Tablets",
    "generic": "Vildagliptin & Metformin HCL",
    "strength": "50mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Diabetology",
    "pack": "As per regulatory specification",
    "desc": "Vildagliptin & Metformin HCL Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0497",
    "name": "Levofloxacin Tablet",
    "generic": "Levofloxacin",
    "strength": "750mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Levofloxacin Tablet — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0498",
    "name": "Cefixime Tablets. 200 Mg",
    "generic": "Cefixime 200 Mg",
    "strength": "200mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime Tablets. 200 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0499",
    "name": "Glimepiride & Metformin Hydrochloride (s R) Tablets",
    "generic": "Glimepiride & Metformin Hydrochloride S R",
    "strength": "1mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Diabetology",
    "pack": "As per regulatory specification",
    "desc": "Glimepiride & Metformin Hydrochloride (s R) Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0500",
    "name": "Glimepiride & Metformin Hydrochloride (s R) Tablets",
    "generic": "Glimepiride & Metformin Hydrochloride S R",
    "strength": "2mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Diabetology",
    "pack": "As per regulatory specification",
    "desc": "Glimepiride & Metformin Hydrochloride (s R) Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0501",
    "name": "Tadalafil Tablets",
    "generic": "Tadalafil",
    "strength": "20mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Urology",
    "pack": "As per regulatory specification",
    "desc": "Tadalafil Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0502",
    "name": "Febuxostat Tablets",
    "generic": "Febuxostat",
    "strength": "40mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Febuxostat Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0503",
    "name": "Ofloxacin Tablets",
    "generic": "Ofloxacin",
    "strength": "400mg",
    "form": "Tablet",
    "category": "tablets",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin Tablets — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0504",
    "name": "Pregabalin, Alpha Lipoic Acid, Vitamine B6, Methylcobalamin, & 700mg Folic Acid Capsules",
    "generic": "Pregabalin",
    "strength": "700mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Pregabalin, Alpha Lipoic Acid, Vitamine B6, Methylcobalamin, & 700mg Folic Acid Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0505",
    "name": "Prebiotic & Probiotic Capsules",
    "generic": "Prebiotic & Probiotic",
    "strength": "0.75billion",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Prebiotic & Probiotic Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0506",
    "name": "Pantoprazole Gastro Resistant & Domperidone Prolonged 40mg Release Capsules",
    "generic": "Pantoprazole Gastro Resistant & Domperidone Prolonged 40mg Release",
    "strength": "40mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Pantoprazole Gastro Resistant & Domperidone Prolonged 40mg Release Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0507",
    "name": "Enteric Coated Rabeprazole Sodium & Sustained Release 20mg Domperidone Capsules",
    "generic": "Enteric Coated Rabeprazole Sodium & Sustained Release 20mg Domperidone",
    "strength": "20mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Enteric Coated Rabeprazole Sodium & Sustained Release 20mg Domperidone Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0508",
    "name": "Rabeprazole Sodium (EC) & Aceclofenac (SR) Capsules",
    "generic": "Rabeprazole Sodium EC & Aceclofenac SR",
    "strength": "20mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Rabeprazole Sodium (EC) & Aceclofenac (SR) Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0509",
    "name": "Tocophenyl Acetate 50% Capsule",
    "generic": "Tocophenyl Acetate 50%",
    "strength": "50%",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Tocophenyl Acetate 50% Capsule — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0510",
    "name": "Doxycycline & Lactic Acid Bacillus Capsules",
    "generic": "Doxycycline & Lactic Acid Bacillus",
    "strength": "100mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Doxycycline & Lactic Acid Bacillus Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0511",
    "name": "Tamsulosin Hydrochloride (pr) & Deflazacort Capsules",
    "generic": "Tamsulosin Hydrochloride Pr & Deflazacort",
    "strength": "0.4mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Urology",
    "pack": "As per regulatory specification",
    "desc": "Tamsulosin Hydrochloride (pr) & Deflazacort Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0512",
    "name": "Loperamide Hydrochloride Capsules",
    "generic": "Loperamide Hydrochloride",
    "strength": "2mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Loperamide Hydrochloride Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0513",
    "name": "Enteric Coated Esomeprazole and Domperidone Sustained 20mg Release Capsules",
    "generic": "Enteric Coated Esomeprazole and Domperidone Sustained 20mg Release",
    "strength": "20mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Enteric Coated Esomeprazole and Domperidone Sustained 20mg Release Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0514",
    "name": "Itraconazole Capsule 100 Mg",
    "generic": "Itraconazole 100 Mg",
    "strength": "100mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Itraconazole Capsule 100 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0515",
    "name": "Itraconazole Capsule 200 Mg",
    "generic": "Itraconazole 200 Mg",
    "strength": "200mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Itraconazole Capsule 200 Mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0516",
    "name": "Amoxycillin Capsule",
    "generic": "Amoxycillin",
    "strength": "500mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin Capsule — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0517",
    "name": "Carbonyl Iron, Folic Acid, Cyanocobalamin, Vit E, Selenium and 100mg Zinc Capsules",
    "generic": "Carbonyl Iron",
    "strength": "100mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Carbonyl Iron, Folic Acid, Cyanocobalamin, Vit E, Selenium and 100mg Zinc Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0518",
    "name": "Multivitamin and Multimineral Capsules",
    "generic": "Multivitamin and Multimineral",
    "strength": "500IU",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Multivitamin and Multimineral Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0519",
    "name": "Omeprazole and Domperidone Capsules",
    "generic": "Omeprazole and Domperidone",
    "strength": "20mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Omeprazole and Domperidone Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0520",
    "name": "Enteric Coated Rabeprazole and Sustained Release 20mg Domperidone Capsules",
    "generic": "Enteric Coated Rabeprazole and Sustained Release 20mg Domperidone",
    "strength": "20mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Enteric Coated Rabeprazole and Sustained Release 20mg Domperidone Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0521",
    "name": "Enteric Coated Pantoprazole and Sustained Release Domperidone Capsules. Each Hard Gelatin Capsule Contians: Pantoprazole Sodium Sesquihydrate",
    "generic": "Enteric Coated Pantoprazole and Sustained Release Domperidone Each Hard Gelatin Contians: Pantoprazole Sodium Sesquihydrate",
    "strength": "0.4mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Enteric Coated Pantoprazole and Sustained Release Domperidone Capsules. Each Hard Gelatin Capsule Contians: Pantoprazole Sodium Sesquihydrate — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0522",
    "name": "Enteric Coated Rabeprazole and Sustained Release 20mg Levosulpiride Capsules",
    "generic": "Enteric Coated Rabeprazole and Sustained Release 20mg Levosulpiride",
    "strength": "20mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Enteric Coated Rabeprazole and Sustained Release 20mg Levosulpiride Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0523",
    "name": "Enteric Coated Esomeprazole and Sustained Release 40mg Domperidone Capsules",
    "generic": "Enteric Coated Esomeprazole and Sustained Release 40mg Domperidone",
    "strength": "40mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Enteric Coated Esomeprazole and Sustained Release 40mg Domperidone Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0524",
    "name": "Carbonyl Iron, Folic Acid, Cyanocobalamin and Selenium with 100mg Zinc Capsules",
    "generic": "Carbonyl Iron",
    "strength": "100mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Carbonyl Iron, Folic Acid, Cyanocobalamin and Selenium with 100mg Zinc Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0525",
    "name": "Amoxycillin Capsule",
    "generic": "Amoxycillin",
    "strength": "250mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin Capsule — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0526",
    "name": "Amoxycillin and Lactic Acid Bacillus Capsules",
    "generic": "Amoxycillin and Lactic Acid Bacillus",
    "strength": "250mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin and Lactic Acid Bacillus Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0527",
    "name": "Amoxycillin and Dicloxacillin with Lactic Acid Bacillus Capsules",
    "generic": "Amoxycillin and Dicloxacillin Lactic Acid Bacillus",
    "strength": "250mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin and Dicloxacillin with Lactic Acid Bacillus Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0528",
    "name": "Amoxycillin and Dicloxacillin Capsules",
    "generic": "Amoxycillin and Dicloxacillin",
    "strength": "250mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin and Dicloxacillin Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0529",
    "name": "Lycopene with Multivitamin & Multimineral Capsules",
    "generic": "Lycopene Multivitamin & Multimineral",
    "strength": "6%",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Lycopene with Multivitamin & Multimineral Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0530",
    "name": "Amoxycillin and Cloxacillin with Lactic Acid Bacillus Capsules",
    "generic": "Amoxycillin and Cloxacillin Lactic Acid Bacillus",
    "strength": "250mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Amoxycillin and Cloxacillin with Lactic Acid Bacillus Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0531",
    "name": "Lycopene with Multivitamin, Multimineral & Antioxidants 10% Capsules",
    "generic": "Lycopene Multivitamin",
    "strength": "As specified",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Lycopene with Multivitamin, Multimineral & Antioxidants 10% Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0532",
    "name": "Methylcobalamin, Alpha Lipoic Acid, Vitamin B6 & Folic Acid 1500mcg Capsules",
    "generic": "Methylcobalamin",
    "strength": "1500mcg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Alpha Lipoic Acid, Vitamin B6 & Folic Acid 1500mcg Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0533",
    "name": "Methylcobalamin, Alpha Lipoic Acid, Pyridoxine HCL & Folic Acid 1500mcg Capsules",
    "generic": "Methylcobalamin",
    "strength": "1500mcg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Alpha Lipoic Acid, Pyridoxine HCL & Folic Acid 1500mcg Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0534",
    "name": "Oseltamivir Phosphate Capsule",
    "generic": "Oseltamivir Phosphate",
    "strength": "30mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Oseltamivir Phosphate Capsule — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0535",
    "name": "Oseltamivir Phosphate Capsule",
    "generic": "Oseltamivir Phosphate",
    "strength": "75mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Oseltamivir Phosphate Capsule — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0536",
    "name": "Enteric Coated Omeprazole and Domperidone Sustained 20mg Release Capsules",
    "generic": "Enteric Coated Omeprazole and Domperidone Sustained 20mg Release",
    "strength": "20mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Enteric Coated Omeprazole and Domperidone Sustained 20mg Release Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0537",
    "name": "Enteric Coated Esomeprazole and Levosulpiride Sustained 40mg Release Capsules",
    "generic": "Enteric Coated Esomeprazole and Levosulpiride Sustained 40mg Release",
    "strength": "40mg",
    "form": "Capsule",
    "category": "capsules",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Enteric Coated Esomeprazole and Levosulpiride Sustained 40mg Release Capsules — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0538",
    "name": "Artemether & Lumefantrine for Oral Suspension",
    "generic": "Artemether & Lumefantrine Oral",
    "strength": "20mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Artemether & Lumefantrine for Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0539",
    "name": "Levosalbutamol, Sulphate, Ambroxol Hydrochloride & 15.00mg Guaiphenesin Syrup",
    "generic": "Levosalbutamol",
    "strength": "15.00mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Levosalbutamol, Sulphate, Ambroxol Hydrochloride & 15.00mg Guaiphenesin Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0540",
    "name": "Calcium Carbonate & Vitamin D3 Suspension",
    "generic": "Calcium Carbonate & Vitamin D3",
    "strength": "625mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Carbonate & Vitamin D3 Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0541",
    "name": "Lysin Withe Multivitamin & Multiminerals Syrup",
    "generic": "Lysin Withe Multivitamin & Multiminerals",
    "strength": "200IU",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Lysin Withe Multivitamin & Multiminerals Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0542",
    "name": "Ambroxol Hydrochloride, Terbutalin Sulphate & Guaiphenesin 30mg Syrup",
    "generic": "Ambroxol Hydrochloride",
    "strength": "30mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Ambroxol Hydrochloride, Terbutalin Sulphate & Guaiphenesin 30mg Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0543",
    "name": "Paracetamol, Phenylephrine HCL & Chlorpheniramine Malteate 125mg Drops",
    "generic": "Paracetamol",
    "strength": "125mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Phenylephrine HCL & Chlorpheniramine Malteate 125mg Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0544",
    "name": "Multivitamins with Choline, Lysine & Zinc Oral Solution. for 5ml Therapeuticn Use Each",
    "generic": "Multivitamins Choline",
    "strength": "5ml",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Multivitamins with Choline, Lysine & Zinc Oral Solution. for 5ml Therapeuticn Use Each — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0545",
    "name": "Drotaverine Hydrochloride Suspension",
    "generic": "Drotaverine Hydrochloride",
    "strength": "20mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Drotaverine Hydrochloride Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0546",
    "name": "Potassium Chloride Oral Solution",
    "generic": "Potassium Chloride Oral",
    "strength": "1.5gm",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Potassium Chloride Oral Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0547",
    "name": "Thiamine Hydrochloride , Pyridone Hydrochloride, Cyanocobalamin, Cyproheptadine HCL, Niacinamide, D-panthenol, Zinc Syrup",
    "generic": "Thiamine Hydrochloride",
    "strength": "1mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Thiamine Hydrochloride , Pyridone Hydrochloride, Cyanocobalamin, Cyproheptadine HCL, Niacinamide, D-panthenol, Zinc Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0548",
    "name": "Acebrophylline Syrup",
    "generic": "Acebrophylline",
    "strength": "10mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Acebrophylline Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0549",
    "name": "Terbutaline Sulphate & Bromhexine Hydrochloride",
    "generic": "Terbutaline Sulphate & Bromhexine Hydrochloride",
    "strength": "2.5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Terbutaline Sulphate & Bromhexine Hydrochloride — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0550",
    "name": "Calcium Carbonate, Zinc, Vitamin D3 & Magnesium Hydroxide 625mg Suspension",
    "generic": "Calcium Carbonate",
    "strength": "625mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Calcium Carbonate, Zinc, Vitamin D3 & Magnesium Hydroxide 625mg Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0551",
    "name": "L-lysine with Multivitamin, Multiminerals & Antioxidant Syrup",
    "generic": "L-lysine Multivitamin",
    "strength": "2.5%",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "L-lysine with Multivitamin, Multiminerals & Antioxidant Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0552",
    "name": "Methylcobalamin, Vitamin D3, Zinc, L-lysine, Niacinamide, Biotin & 500mcg Folic Acid Syrup",
    "generic": "Methylcobalamin",
    "strength": "500mcg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Methylcobalamin, Vitamin D3, Zinc, L-lysine, Niacinamide, Biotin & 500mcg Folic Acid Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0553",
    "name": "Cyproheptadine Hydrochloride & Tricholine Citrate (65%) Syrup",
    "generic": "Cyproheptadine Hydrochloride & Tricholine Citrate 65%",
    "strength": "2mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Cyproheptadine Hydrochloride & Tricholine Citrate (65%) Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0554",
    "name": "Zinc Gluconate Oral Solution",
    "generic": "Zinc Gluconate Oral",
    "strength": "20mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Zinc Gluconate Oral Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0555",
    "name": "Levetiracetam Oral Solution",
    "generic": "Levetiracetam Oral",
    "strength": "100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Neurology",
    "pack": "As per regulatory specification",
    "desc": "Levetiracetam Oral Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0556",
    "name": "Ibuprofen & Paracetamol Suspension",
    "generic": "Ibuprofen & Paracetamol",
    "strength": "100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Ibuprofen & Paracetamol Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0557",
    "name": "Linezolid for Oral Suspension",
    "generic": "Linezolid Oral",
    "strength": "100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Linezolid for Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0558",
    "name": "Colistin Sulphate for Oral Suspension",
    "generic": "Colistin Sulphate Oral",
    "strength": "25mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Colistin Sulphate for Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0559",
    "name": "Colistin Sulphate for Oral Suspension",
    "generic": "Colistin Sulphate Oral",
    "strength": "12.5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Colistin Sulphate for Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0560",
    "name": "Ambroxol Hydrochloride & Levocetirizine Dihydrochloride 15mg Syrup",
    "generic": "Ambroxol Hydrochloride & Levocetirizine Dihydrochloride 15mg",
    "strength": "15mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Ambroxol Hydrochloride & Levocetirizine Dihydrochloride 15mg Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0561",
    "name": "Ambroxol Hydrochloride & Levocetirizine Dihydrochloride 30mg Syrup",
    "generic": "Ambroxol Hydrochloride & Levocetirizine Dihydrochloride 30mg",
    "strength": "30mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Ambroxol Hydrochloride & Levocetirizine Dihydrochloride 30mg Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0562",
    "name": "Simethicone Drops",
    "generic": "Simethicone",
    "strength": "100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Simethicone Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0563",
    "name": "Ambroxol Hydrochloride & Cetirizine Hydrochloride Syrup",
    "generic": "Ambroxol Hydrochloride & Cetirizine Hydrochloride",
    "strength": "15mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Ambroxol Hydrochloride & Cetirizine Hydrochloride Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0564",
    "name": "Ambroxol Hydrochloride & Cetirizine Hydrochloride Syrup",
    "generic": "Ambroxol Hydrochloride & Cetirizine Hydrochloride",
    "strength": "30mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Ambroxol Hydrochloride & Cetirizine Hydrochloride Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0565",
    "name": "Ambroxol Hydrochloride Syrup",
    "generic": "Ambroxol Hydrochloride",
    "strength": "15mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Ambroxol Hydrochloride Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0566",
    "name": "Ambroxol Hydrochloride Syrup",
    "generic": "Ambroxol Hydrochloride",
    "strength": "30mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Ambroxol Hydrochloride Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0567",
    "name": "Ofloxacin and Racecadotril Suspension",
    "generic": "Ofloxacin and Racecadotril",
    "strength": "50mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin and Racecadotril Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0568",
    "name": "Ambroxol Hydrochloride, Terbutaline Sulphate & Guaiphenesin 15mg Syrup",
    "generic": "Ambroxol Hydrochloride",
    "strength": "15mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Ambroxol Hydrochloride, Terbutaline Sulphate & Guaiphenesin 15mg Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0569",
    "name": "Calcium, Vitamin D3, Magnesium & Zinc Suspension",
    "generic": "Calcium",
    "strength": "625mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium, Vitamin D3, Magnesium & Zinc Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0570",
    "name": "Montelukast Sodium & Levocetirizine Di-hydrochloride Syrup",
    "generic": "Montelukast Sodium & Levocetirizine Di-hydrochloride",
    "strength": "4mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Montelukast Sodium & Levocetirizine Di-hydrochloride Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0571",
    "name": "Lactulose Solution",
    "generic": "Lactulose",
    "strength": "10gm",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Lactulose Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0572",
    "name": "Cefixime with Lactic Acid Bacillus Oral Suspension",
    "generic": "Cefixime Lactic Acid Bacillus Oral",
    "strength": "100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime with Lactic Acid Bacillus Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0573",
    "name": "L-lysine, Vitamin B1, Vitaminb2, (riboflavin Sodium Phosphate ), Vitamin B6,vitamin B12, Niacinamide, Calcium Dpantothenate,methylcobalamin Syrup",
    "generic": "L-lysine",
    "strength": "375mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "L-lysine, Vitamin B1, Vitaminb2, (riboflavin Sodium Phosphate ), Vitamin B6,vitamin B12, Niacinamide, Calcium Dpantothenate,methylcobalamin Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0574",
    "name": "Potassium Citrate,magnesium Citrate & Vitamin B6 Oral Solution",
    "generic": "Potassium Citrate",
    "strength": "1100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Potassium Citrate,magnesium Citrate & Vitamin B6 Oral Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0575",
    "name": "Dextromethorphan Hydrobromide, Phenylephrine 15mg Hydrochloride & Chlorpheniramine Maleate Syrup",
    "generic": "Dextromethorphan Hydrobromide",
    "strength": "15mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Dextromethorphan Hydrobromide, Phenylephrine 15mg Hydrochloride & Chlorpheniramine Maleate Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0576",
    "name": "Dextromethorphan Hydrobromide, Phenylephrine 5mg Hydrochloride & Chlorpheniramine Maleate Syrup",
    "generic": "Dextromethorphan Hydrobromide",
    "strength": "5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Dextromethorphan Hydrobromide, Phenylephrine 5mg Hydrochloride & Chlorpheniramine Maleate Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0577",
    "name": "Zinc Sulfate Monohydrate Oral Suspension",
    "generic": "Zinc Sulfate Monohydrate Oral",
    "strength": "10mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Zinc Sulfate Monohydrate Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0578",
    "name": "Ofloxacin & Metronidazole Suspension",
    "generic": "Ofloxacin & Metronidazole",
    "strength": "50mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin & Metronidazole Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0579",
    "name": "Sodium Picosulfate, Milk of Magnesia & Liquid Paraffin 3.33mg Suspension",
    "generic": "Sodium Picosulfate",
    "strength": "3.33mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Sodium Picosulfate, Milk of Magnesia & Liquid Paraffin 3.33mg Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0580",
    "name": "Paracetamol & Mefenamic Acid Suspension",
    "generic": "Paracetamol & Mefenamic Acid",
    "strength": "250mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol & Mefenamic Acid Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0581",
    "name": "Chlorpheniramine Maleate & Phenylephrine Hydrochloride 2mg Drops",
    "generic": "Chlorpheniramine Maleate & Phenylephrine Hydrochloride 2mg",
    "strength": "2mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Chlorpheniramine Maleate & Phenylephrine Hydrochloride 2mg Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0582",
    "name": "Paracetamol, Chlorpheniramine Maleate, Phenylephrine 250mg Hydrochloride, Sodium Citrate & Menthol Oral Suspension",
    "generic": "Paracetamol",
    "strength": "250mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Chlorpheniramine Maleate, Phenylephrine 250mg Hydrochloride, Sodium Citrate & Menthol Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0583",
    "name": "Vitamin D3 Oral Solution",
    "generic": "Vitamin D3 Oral",
    "strength": "000IU",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Vitamin D3 Oral Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0584",
    "name": "Terbutaline, Ambroxol, Guaiphenesin and Menthol Syrup",
    "generic": "Terbutaline",
    "strength": "1.25mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Terbutaline, Ambroxol, Guaiphenesin and Menthol Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0585",
    "name": "Dextromethorphan, Phenylephrine and Cetirizine Di HCL Syrup",
    "generic": "Dextromethorphan",
    "strength": "10mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Dextromethorphan, Phenylephrine and Cetirizine Di HCL Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0586",
    "name": "Ofloxacin and Ornidazole Suspension",
    "generic": "Ofloxacin and Ornidazole",
    "strength": "50mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin and Ornidazole Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0587",
    "name": "Albendazole and Ivermectin Suspension",
    "generic": "Albendazole and Ivermectin",
    "strength": "200mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Albendazole and Ivermectin Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0588",
    "name": "Diphenhydramine, Ammonium Chloride, Sodium Citrate and 14.8mg Menthol Syrup",
    "generic": "Diphenhydramine",
    "strength": "14.8mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Diphenhydramine, Ammonium Chloride, Sodium Citrate and 14.8mg Menthol Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0589",
    "name": "Magaldrate & Simethicone with Oxetacaine Suspension",
    "generic": "Magaldrate & Simethicone Oxetacaine",
    "strength": "540mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Magaldrate & Simethicone with Oxetacaine Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0590",
    "name": "Terbutaline, Bromhexine, Guaiphenesin and Menthol Syrup",
    "generic": "Terbutaline",
    "strength": "1.25mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Terbutaline, Bromhexine, Guaiphenesin and Menthol Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0591",
    "name": "Mefenamic Acid and Paracetamol Suspension",
    "generic": "Mefenamic Acid and Paracetamol",
    "strength": "50mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Mefenamic Acid and Paracetamol Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0592",
    "name": "Aluminium Hydroxide, Magnesium Hydroxide and Simethicone 250mg Suspension",
    "generic": "Aluminium Hydroxide",
    "strength": "250mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Aluminium Hydroxide, Magnesium Hydroxide and Simethicone 250mg Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0593",
    "name": "Magaldrate and Simethicone Suspension",
    "generic": "Magaldrate and Simethicone",
    "strength": "400mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Magaldrate and Simethicone Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0594",
    "name": "Ondansetron Oral Solution",
    "generic": "Ondansetron Oral",
    "strength": "2mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Ondansetron Oral Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0595",
    "name": "Levocetirizine Dihydrochloride Suspension",
    "generic": "Levocetirizine Dihydrochloride",
    "strength": "5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Levocetirizine Dihydrochloride Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0596",
    "name": "Tricholine Citrate Syrup",
    "generic": "Tricholine Citrate",
    "strength": "275mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Tricholine Citrate Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0597",
    "name": "Ondansetron Oral Solution",
    "generic": "Ondansetron Oral",
    "strength": "5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Ondansetron Oral Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0598",
    "name": "Phenylephrine HCL, Chlorpheniramine Maleate, Sodium Citrate 5mg and Paracetamol Suspension",
    "generic": "Phenylephrine HCL",
    "strength": "5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Phenylephrine HCL, Chlorpheniramine Maleate, Sodium Citrate 5mg and Paracetamol Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0599",
    "name": "Dicyclomine HCL and Simethicone Suspension",
    "generic": "Dicyclomine HCL and Simethicone",
    "strength": "10mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Dicyclomine HCL and Simethicone Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0600",
    "name": "Phenylephrine HCL, Chlorpheniramine Maleate and Paracetamol 1mg Suspension",
    "generic": "Phenylephrine HCL",
    "strength": "1mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Phenylephrine HCL, Chlorpheniramine Maleate and Paracetamol 1mg Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0601",
    "name": "Albendazole Suspension",
    "generic": "Albendazole",
    "strength": "200mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Albendazole Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0602",
    "name": "Ofloxacin and Metronidazole Suspension",
    "generic": "Ofloxacin and Metronidazole",
    "strength": "50mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin and Metronidazole Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0603",
    "name": "Paracetamol Suspension",
    "generic": "Paracetamol",
    "strength": "250mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0604",
    "name": "Sucralfate Suspension",
    "generic": "Sucralfate",
    "strength": "500mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Sucralfate Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0605",
    "name": "Aluminium Hydroxide Gel, Magnesium Hydroxide and Activated 250mg Dimethicone Suspension",
    "generic": "Aluminium Hydroxide Gel",
    "strength": "250mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Aluminium Hydroxide Gel, Magnesium Hydroxide and Activated 250mg Dimethicone Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0606",
    "name": "Phenylephrine HCL, Chlorpheniramine Maleate and Paracetamol 2.5mg Drops",
    "generic": "Phenylephrine HCL",
    "strength": "2.5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Phenylephrine HCL, Chlorpheniramine Maleate and Paracetamol 2.5mg Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0607",
    "name": "Disodium Hydrogen Citrate Syrup",
    "generic": "Disodium Hydrogen Citrate",
    "strength": "14mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Disodium Hydrogen Citrate Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0608",
    "name": "Sodium Picosulphate Syrup",
    "generic": "Sodium Picosulphate",
    "strength": "5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Sodium Picosulphate Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0609",
    "name": "Promethazine Hydrochloride & Paracetamol Suspension",
    "generic": "Promethazine Hydrochloride & Paracetamol",
    "strength": "2.5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Promethazine Hydrochloride & Paracetamol Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0610",
    "name": "Magaldrate and Simehicone with Domperidone Oral Suspension",
    "generic": "Magaldrate and Simehicone Domperidone Oral",
    "strength": "400mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Magaldrate and Simehicone with Domperidone Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0611",
    "name": "Magaldrate and Simethicone with Oxetacaine Oral Suspension",
    "generic": "Magaldrate and Simethicone Oxetacaine Oral",
    "strength": "480mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Magaldrate and Simethicone with Oxetacaine Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0612",
    "name": "Paracetamol, Ambroxol HCL, Phenylephrine HCL and 125mg Chlorpheniramine Maleate Syrup",
    "generic": "Paracetamol",
    "strength": "125mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Ambroxol HCL, Phenylephrine HCL and 125mg Chlorpheniramine Maleate Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0613",
    "name": "Magnesium Hydroxide, Dried Aluminium Hydroxide and 98mg Oxetacaine Suspension",
    "generic": "Magnesium Hydroxide",
    "strength": "98mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Magnesium Hydroxide, Dried Aluminium Hydroxide and 98mg Oxetacaine Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0614",
    "name": "Mefenamic Acid with Paracetamol Suspension",
    "generic": "Mefenamic Acid Paracetamol",
    "strength": "100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Pain Management",
    "pack": "As per regulatory specification",
    "desc": "Mefenamic Acid with Paracetamol Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0615",
    "name": "Magaldrate & Simethicone Oral Solution",
    "generic": "Magaldrate & Simethicone Oral",
    "strength": "480mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Magaldrate & Simethicone Oral Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0616",
    "name": "Levosalbutamol, Ambroxol & Guaiphenesin Syrup",
    "generic": "Levosalbutamol",
    "strength": "30mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Levosalbutamol, Ambroxol & Guaiphenesin Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0617",
    "name": "Levosalbutamol, Ambroxol & Guaiphenesin Drops",
    "generic": "Levosalbutamol",
    "strength": "7.5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Levosalbutamol, Ambroxol & Guaiphenesin Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0618",
    "name": "Cefpodoxime Proxetil Suspension",
    "generic": "Cefpodoxime Proxetil",
    "strength": "50mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefpodoxime Proxetil Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0619",
    "name": "Azithromycin Oral Suspension",
    "generic": "Azithromycin Oral",
    "strength": "100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Azithromycin Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0620",
    "name": "Cefixime Oral Suspension",
    "generic": "Cefixime Oral",
    "strength": "50mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0621",
    "name": "Fungal Diastase and Pepsin Syrup",
    "generic": "Fungal Diastase and Pepsin",
    "strength": "50mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Fungal Diastase and Pepsin Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0622",
    "name": "Fungal Diastase and Pepsin Syrup",
    "generic": "Fungal Diastase and Pepsin",
    "strength": "33.33mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Fungal Diastase and Pepsin Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0623",
    "name": "Cefpodoxime Oral Suspension. Each",
    "generic": "Cefpodoxime Oral Each",
    "strength": "5ml",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefpodoxime Oral Suspension. Each — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0624",
    "name": "Cefixime and Lactic Acid Bacillus Oral Suspension",
    "generic": "Cefixime and Lactic Acid Bacillus Oral",
    "strength": "50mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime and Lactic Acid Bacillus Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0625",
    "name": "Ferric Ammonium Citrate, Folic Acid, Cyanocobalamin with 160mg Sorbitol Syrup",
    "generic": "Ferric Ammonium Citrate",
    "strength": "160mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferric Ammonium Citrate, Folic Acid, Cyanocobalamin with 160mg Sorbitol Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0626",
    "name": "Ferrous Ascorbate, Folic Acid, Zinc and Methylcobalamin Syrup",
    "generic": "Ferrous Ascorbate",
    "strength": "30mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate, Folic Acid, Zinc and Methylcobalamin Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0627",
    "name": "Lycopene, Niacinamide, Vit B6, Cyanocobalamin, Folic Acid, 2000mcg Selenium, Zinc, Iodine and Copper Sulphate Syrup",
    "generic": "Lycopene",
    "strength": "2000mcg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Lycopene, Niacinamide, Vit B6, Cyanocobalamin, Folic Acid, 2000mcg Selenium, Zinc, Iodine and Copper Sulphate Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0628",
    "name": "Calcium Carbonate, Vitamin D3 and L-lysine Syrup",
    "generic": "Calcium Carbonate",
    "strength": "375mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Carbonate, Vitamin D3 and L-lysine Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0629",
    "name": "Multivitamin and Multimineral Syrup",
    "generic": "Multivitamin and Multimineral",
    "strength": "60mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Multivitamin and Multimineral Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0630",
    "name": "Ferrous Gluconate, Folic Acid, Calcium Lactate and Vit B12 129.5mg Syrup",
    "generic": "Ferrous Gluconate",
    "strength": "129.5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Gluconate, Folic Acid, Calcium Lactate and Vit B12 129.5mg Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0631",
    "name": "Vitamin B-complex with L-lysine Syrup",
    "generic": "Vitamin B-complex L-lysine",
    "strength": "2mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Vitamin B-complex with L-lysine Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0632",
    "name": "Dextromethorphan, Chlorpheniramine and Phenylephrine Syup",
    "generic": "Dextromethorphan",
    "strength": "10mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Dextromethorphan, Chlorpheniramine and Phenylephrine Syup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0633",
    "name": "Sucralfate and Oxetacaine Suspension",
    "generic": "Sucralfate and Oxetacaine",
    "strength": "1000mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Sucralfate and Oxetacaine Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0634",
    "name": "Magaldrate & Simethicone with Oxetacaine Suspension Each",
    "generic": "Magaldrate & Simethicone Oxetacaine Each",
    "strength": "5ml",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Magaldrate & Simethicone with Oxetacaine Suspension Each — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0635",
    "name": "Cyproheptadine Hydrochloride and Tricholine Citrate Syrup",
    "generic": "Cyproheptadine Hydrochloride and Tricholine Citrate",
    "strength": "2mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Cyproheptadine Hydrochloride and Tricholine Citrate Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0636",
    "name": "Potassium Nitrate and Sodium Monofluro Phosphate Solution 5%w/v Potassium Nitrate",
    "generic": "Potassium Nitrate and Sodium Monofluro Phosphate 5%w/v Potassium Nitrate",
    "strength": "5%",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Potassium Nitrate and Sodium Monofluro Phosphate Solution 5%w/v Potassium Nitrate — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0637",
    "name": "Chlorhexidine Gluconate Solution",
    "generic": "Chlorhexidine Gluconate",
    "strength": "0.20%v/v",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Chlorhexidine Gluconate Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0638",
    "name": "Paracetamol Suspension",
    "generic": "Paracetamol",
    "strength": "125mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0639",
    "name": "Dextromethorphan Hydrobromide , Phenylephrine HCL and 10mg Chlorpheniramine Maleate Syrup",
    "generic": "Dextromethorphan Hydrobromide",
    "strength": "10mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Dextromethorphan Hydrobromide , Phenylephrine HCL and 10mg Chlorpheniramine Maleate Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0640",
    "name": "Azithromycin Oral Suspension",
    "generic": "Azithromycin Oral",
    "strength": "200mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Azithromycin Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0641",
    "name": "Promethazine HCL & Paracetamol Syrup",
    "generic": "Promethazine HCL & Paracetamol",
    "strength": "5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Promethazine HCL & Paracetamol Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0642",
    "name": "Phenylephrine HCL and Chlorpheniramine Maleate Syrup",
    "generic": "Phenylephrine HCL and Chlorpheniramine Maleate",
    "strength": "5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Phenylephrine HCL and Chlorpheniramine Maleate Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0643",
    "name": "Promethazine Hydrochloride Syrup",
    "generic": "Promethazine Hydrochloride",
    "strength": "5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Promethazine Hydrochloride Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0644",
    "name": "Paracetamol, Phenylephrine HCL and Chlorpheniramine Maleate 2.5mg Suspension",
    "generic": "Paracetamol",
    "strength": "2.5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol, Phenylephrine HCL and Chlorpheniramine Maleate 2.5mg Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0645",
    "name": "Dicyclomine and Paracetamol Suspension",
    "generic": "Dicyclomine and Paracetamol",
    "strength": "10mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Dicyclomine and Paracetamol Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0646",
    "name": "Calcium Gluconate, Ferrous Gluconate, Folic Acid and Zinc 100mg Sulphate Syrup",
    "generic": "Calcium Gluconate",
    "strength": "100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Gluconate, Ferrous Gluconate, Folic Acid and Zinc 100mg Sulphate Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0647",
    "name": "Ferrous Ascorbate and Folic Acid Syrup",
    "generic": "Ferrous Ascorbate and Folic Acid",
    "strength": "30mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate and Folic Acid Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0648",
    "name": "Calcium Lactate, Calcium Gluconate & Vitamin D3 Syrup",
    "generic": "Calcium Lactate",
    "strength": "200mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Calcium Lactate, Calcium Gluconate & Vitamin D3 Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0649",
    "name": "Ferrous Ascorbate and Folic Acid Syrup",
    "generic": "Ferrous Ascorbate and Folic Acid",
    "strength": "10mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate and Folic Acid Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0650",
    "name": "Cefixime Oral Suspension",
    "generic": "Cefixime Oral",
    "strength": "100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefixime Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0651",
    "name": "Chlorpheniramine Maleate, Sodium Citrate, Ammonium Chloride 4mg & Menthol Syrup",
    "generic": "Chlorpheniramine Maleate",
    "strength": "4mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Chlorpheniramine Maleate, Sodium Citrate, Ammonium Chloride 4mg & Menthol Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0652",
    "name": "Dried Aluminium Hydroxide, Magnesium Hydroxide, Simethicone 300mg Syrup with Sorbitol and Dil Oil",
    "generic": "Dried Aluminium Hydroxide",
    "strength": "300mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Dried Aluminium Hydroxide, Magnesium Hydroxide, Simethicone 300mg Syrup with Sorbitol and Dil Oil — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0653",
    "name": "Albendazole and Ivermectin Suspension",
    "generic": "Albendazole and Ivermectin",
    "strength": "125mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Albendazole and Ivermectin Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0654",
    "name": "Iron, Folic Acid, Vitamin B12 & Zinc Syrup",
    "generic": "Iron",
    "strength": "160mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Iron, Folic Acid, Vitamin B12 & Zinc Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0655",
    "name": "Aluminium Hydroxide, Dimethyl Polysiloxane & Magnesium 250mg Hydroxide Suspension",
    "generic": "Aluminium Hydroxide",
    "strength": "250mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Aluminium Hydroxide, Dimethyl Polysiloxane & Magnesium 250mg Hydroxide Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0656",
    "name": "Ambroxol Hydrochloride, Guaiphenesin & Terbutaline Drops",
    "generic": "Ambroxol Hydrochloride",
    "strength": "7.5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Ambroxol Hydrochloride, Guaiphenesin & Terbutaline Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0657",
    "name": "Phenylephrine Hydrochloride, Chlorpheniramine Maleate, 5mg Sodium Citrate & Menthol Suspension",
    "generic": "Phenylephrine Hydrochloride",
    "strength": "5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Phenylephrine Hydrochloride, Chlorpheniramine Maleate, 5mg Sodium Citrate & Menthol Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0658",
    "name": "Ferrous Ascorbate, Folic Acid & Methylcobalamin Suspension",
    "generic": "Ferrous Ascorbate",
    "strength": "30mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "Ferrous Ascorbate, Folic Acid & Methylcobalamin Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0659",
    "name": "Phenylephrine Hydrochloride, Chlorpheniramine Maleate & 5mg Paracetamol Suspension",
    "generic": "Phenylephrine Hydrochloride",
    "strength": "5mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Respiratory",
    "pack": "As per regulatory specification",
    "desc": "Phenylephrine Hydrochloride, Chlorpheniramine Maleate & 5mg Paracetamol Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0660",
    "name": "Albendazole Suspension",
    "generic": "Albendazole",
    "strength": "100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Albendazole Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0661",
    "name": "A Tonic with Iron & Vitamin Syrup",
    "generic": "A Tonic Iron & Vitamin",
    "strength": "30mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Nutraceuticals",
    "pack": "As per regulatory specification",
    "desc": "A Tonic with Iron & Vitamin Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0662",
    "name": "Oxymetazoline Hydrochloride",
    "generic": "Oxymetazoline Hydrochloride",
    "strength": "0.05%w/v",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "ENT",
    "pack": "As per regulatory specification",
    "desc": "Oxymetazoline Hydrochloride — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0663",
    "name": "Oxymetazoline Hydrochloride",
    "generic": "Oxymetazoline Hydrochloride",
    "strength": "0.1%w/v",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "ENT",
    "pack": "As per regulatory specification",
    "desc": "Oxymetazoline Hydrochloride — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0664",
    "name": "Paracetamol Oral Solution for Paediatric Use Only)",
    "generic": "Paracetamol Oral Paediatric Use Only",
    "strength": "150mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Pediatrics",
    "pack": "As per regulatory specification",
    "desc": "Paracetamol Oral Solution for Paediatric Use Only) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0665",
    "name": "Cefpodoxime Proxetil Oral Suspension. for Paediatric Use 25mg Only)",
    "generic": "Cefpodoxime Proxetil Oral Paediatric Use 25mg Only",
    "strength": "25mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Cefpodoxime Proxetil Oral Suspension. for Paediatric Use 25mg Only) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0666",
    "name": "Acetaminophen Oral Suspension. for Paediatric Use Only)",
    "generic": "Acetaminophen Oral Paediatric Use Only",
    "strength": "100mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Pediatrics",
    "pack": "As per regulatory specification",
    "desc": "Acetaminophen Oral Suspension. for Paediatric Use Only) — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0667",
    "name": "Sucralfate Suspension",
    "generic": "Sucralfate",
    "strength": "1000mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Sucralfate Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0668",
    "name": "Acetaminophen Suspension",
    "generic": "Acetaminophen",
    "strength": "125mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Pediatrics",
    "pack": "As per regulatory specification",
    "desc": "Acetaminophen Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0669",
    "name": "Chlorhexidine Gluconate Solution",
    "generic": "Chlorhexidine Gluconate",
    "strength": "0.2%w/v",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Chlorhexidine Gluconate Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0670",
    "name": "Dried Aluminum, Magnesium and Simethicone Oral Suspension",
    "generic": "Dried Aluminum",
    "strength": "185mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Dried Aluminum, Magnesium and Simethicone Oral Suspension — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0671",
    "name": "Buclizine Syrup",
    "generic": "Buclizine",
    "strength": "6mg",
    "form": "Oral Liquid",
    "category": "oral-liquids",
    "segment": "Gastroenterology",
    "pack": "As per regulatory specification",
    "desc": "Buclizine Syrup — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0672",
    "name": "Saline Nasal Solution",
    "generic": "Saline Nasal",
    "strength": "0.65%w/v",
    "form": "Nasal Drops",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "As per regulatory specification",
    "desc": "Saline Nasal Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0673",
    "name": "Xylometazoline Hydrochloride Nasal Drops",
    "generic": "Xylometazoline Hydrochloride Nasal",
    "strength": "0.05%w/v",
    "form": "Nasal Drops",
    "category": "nasal-sprays",
    "segment": "ENT",
    "pack": "As per regulatory specification",
    "desc": "Xylometazoline Hydrochloride Nasal Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0674",
    "name": "Sodium Chloride",
    "generic": "Sodium Chloride",
    "strength": "0.65%w/v",
    "form": "Nasal Drops",
    "category": "nasal-sprays",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Sodium Chloride — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0675",
    "name": "Moxifloxacin Hydrochloride and Ketorolac Ophthalmic 0.5%w/v Solution",
    "generic": "Moxifloxacin Hydrochloride and Ketorolac Ophthalmic 0 5%w/v",
    "strength": "0.5%",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Moxifloxacin Hydrochloride and Ketorolac Ophthalmic 0.5%w/v Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0676",
    "name": "Carmellose Sodium Eye Drops 5mg",
    "generic": "Carmellose Sodium Eye 5mg",
    "strength": "0.5% W/V",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "As per regulatory specification",
    "desc": "Carmellose Sodium Eye Drops 5mg — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0677",
    "name": "Ciprofloxacin Eye Drops. Ciprofloxacin Hydrochloride",
    "generic": "Ciprofloxacin Eye Ciprofloxacin Hydrochloride",
    "strength": "0.3%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ciprofloxacin Eye Drops. Ciprofloxacin Hydrochloride — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0678",
    "name": "Ciprofloxacin & Dexamethasone Eye Drops. Ciprofloxacin 0.3%w/v Hydrochloride",
    "generic": "Ciprofloxacin & Dexamethasone Eye Ciprofloxacin 0 3%w/v Hydrochloride",
    "strength": "0.3%",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ciprofloxacin & Dexamethasone Eye Drops. Ciprofloxacin 0.3%w/v Hydrochloride — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0679",
    "name": "Ofloxacin & Dexamethasone Sodium Phosphate Eye/ear Drops",
    "generic": "Ofloxacin & Dexamethasone Sodium Phosphate Eye/ear",
    "strength": "0.3%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin & Dexamethasone Sodium Phosphate Eye/ear Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0680",
    "name": "Moxifloxacin Hydrochloride & Dexamethasone Sodium 0.5%w/v Phosphate Eye Drops",
    "generic": "Moxifloxacin Hydrochloride & Dexamethasone Sodium 0 5%w/v Phosphate Eye",
    "strength": "0.5%",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Moxifloxacin Hydrochloride & Dexamethasone Sodium 0.5%w/v Phosphate Eye Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0681",
    "name": "Gentamicin, Clotrimazole, Lignocaine HCL. & Beclomethasone Dipropionate Ear Drops.(for External Use Only) Gentamicin Sulphate",
    "generic": "Gentamicin",
    "strength": "0.3%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Gentamicin, Clotrimazole, Lignocaine HCL. & Beclomethasone Dipropionate Ear Drops.(for External Use Only) Gentamicin Sulphate — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0682",
    "name": "Moxifloxacin & Ketorolac Tromethamine Ophthalmic Solution. 0.5%w/v Moxifloxacin Hydrochloride",
    "generic": "Moxifloxacin & Ketorolac Tromethamine Ophthalmic 0 5%w/v Moxifloxacin Hydrochloride",
    "strength": "0.5%",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Moxifloxacin & Ketorolac Tromethamine Ophthalmic Solution. 0.5%w/v Moxifloxacin Hydrochloride — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0683",
    "name": "Sodium Carboxymethyl Cellulose Eye Drops. Each Ml Contains 0.50%w/v Sodium Carboxymethyl Cellulose",
    "generic": "Sodium Carboxymethyl Cellulose Eye Each Ml Contains 0 50%w/v Sodium Carboxymethyl Cellulose",
    "strength": "0.50%",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "As per regulatory specification",
    "desc": "Sodium Carboxymethyl Cellulose Eye Drops. Each Ml Contains 0.50%w/v Sodium Carboxymethyl Cellulose — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0684",
    "name": "Sodium Carboxymethyl Cellulose Eye Drops. Each Ml Contains 1% Sodium Carboxymethyl Cellulose",
    "generic": "Sodium Carboxymethyl Cellulose Eye Each Ml Contains 1% Sodium Carboxymethyl Cellulose",
    "strength": "As specified",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "As per regulatory specification",
    "desc": "Sodium Carboxymethyl Cellulose Eye Drops. Each Ml Contains 1% Sodium Carboxymethyl Cellulose — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0685",
    "name": "Ofloxacin & Dexamethasone Sodium Phosphate Eye Drops",
    "generic": "Ofloxacin & Dexamethasone Sodium Phosphate Eye",
    "strength": "0.30%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin & Dexamethasone Sodium Phosphate Eye Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0686",
    "name": "Moxifloxacin Eye Drops. Moxifloxacin HCL",
    "generic": "Moxifloxacin Eye Moxifloxacin HCL",
    "strength": "0.50%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Moxifloxacin Eye Drops. Moxifloxacin HCL — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0687",
    "name": "Dexamethasone with Chloramphenicol Eye/ear Drops. 0.01%w/v Dexamethasone Sodium Phosphate",
    "generic": "Dexamethasone Chloramphenicol Eye/ear 0 01%w/v Dexamethasone Sodium Phosphate",
    "strength": "0.01%",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "ENT",
    "pack": "As per regulatory specification",
    "desc": "Dexamethasone with Chloramphenicol Eye/ear Drops. 0.01%w/v Dexamethasone Sodium Phosphate — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0688",
    "name": "Chloramphenicol with Benzocaine Eye/ear Drops",
    "generic": "Chloramphenicol Benzocaine Eye/ear",
    "strength": "5%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "ENT",
    "pack": "As per regulatory specification",
    "desc": "Chloramphenicol with Benzocaine Eye/ear Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0689",
    "name": "Chloramphenicol, Beclomethasone Dipropionate & Lignocaine 0.5%w/v HCL Ear Drops",
    "generic": "Chloramphenicol",
    "strength": "0.5%",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "ENT",
    "pack": "As per regulatory specification",
    "desc": "Chloramphenicol, Beclomethasone Dipropionate & Lignocaine 0.5%w/v HCL Ear Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0690",
    "name": "Clotrimazole & Lignocaine HCL Ear Drops",
    "generic": "Clotrimazole & Lignocaine HCL Ear",
    "strength": "1.00%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "ENT",
    "pack": "As per regulatory specification",
    "desc": "Clotrimazole & Lignocaine HCL Ear Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0691",
    "name": "Ofloxacin, Dexamethasone & Polyvinyl Alcohol Opthalmic 0.30%w/v Solution. Each Ml Contains Ofloxacin",
    "generic": "Ofloxacin",
    "strength": "0.30%",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin, Dexamethasone & Polyvinyl Alcohol Opthalmic 0.30%w/v Solution. Each Ml Contains Ofloxacin — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0692",
    "name": "Ofloxacin with Benzalkonium Chloride Solution Eye Drops",
    "generic": "Ofloxacin Benzalkonium Chloride Eye",
    "strength": "0.30%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin with Benzalkonium Chloride Solution Eye Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0693",
    "name": "Ofloxacin & Hydroxypropyl Methyl Cellulose Eye/ear Drops",
    "generic": "Ofloxacin & Hydroxypropyl Methyl Cellulose Eye/ear",
    "strength": "0.30%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ofloxacin & Hydroxypropyl Methyl Cellulose Eye/ear Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0694",
    "name": "Clotrimazole, Betamethasone Dipropionate, Lignocaine HCL & 1.00%w/v Ofloxacin Ear Drops",
    "generic": "Clotrimazole",
    "strength": "1.00%",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Clotrimazole, Betamethasone Dipropionate, Lignocaine HCL & 1.00%w/v Ofloxacin Ear Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0695",
    "name": "Tobramycin Sulphate Eye Drops",
    "generic": "Tobramycin Sulphate Eye",
    "strength": "0.30%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "As per regulatory specification",
    "desc": "Tobramycin Sulphate Eye Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0696",
    "name": "Mesna Respirator Solution",
    "generic": "Mesna Respirator",
    "strength": "600mg",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Critical Care",
    "pack": "As per regulatory specification",
    "desc": "Mesna Respirator Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0697",
    "name": "Ciprofloxacin Ophthalmic Solution 0.3 % W/V",
    "generic": "Ciprofloxacin Ophthalmic 0 3 % W/V",
    "strength": "0.30%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ciprofloxacin Ophthalmic Solution 0.3 % W/V — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0698",
    "name": "Gentamicin Sulfate Ophthalmic Solution 0.3 % W/V",
    "generic": "Gentamicin Sulfate Ophthalmic 0 3 % W/V",
    "strength": "0.30%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Gentamicin Sulfate Ophthalmic Solution 0.3 % W/V — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0699",
    "name": "Tobramycin Ophthalmic Solution",
    "generic": "Tobramycin Ophthalmic",
    "strength": "0.30%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "As per regulatory specification",
    "desc": "Tobramycin Ophthalmic Solution — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0700",
    "name": "Timolol Eye Drops",
    "generic": "Timolol Eye",
    "strength": "0.50%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Ophthalmology",
    "pack": "As per regulatory specification",
    "desc": "Timolol Eye Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0701",
    "name": "Ciprofloxacin & Dexamethasone Eye Drops",
    "generic": "Ciprofloxacin & Dexamethasone Eye",
    "strength": "0.30%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Ciprofloxacin & Dexamethasone Eye Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0702",
    "name": "Dexamethasone Sodium Phosphate & Chloramphenicol Eye/ear 0.05%w/v Drops",
    "generic": "Dexamethasone Sodium Phosphate & Chloramphenicol Eye/ear 0 05%w/v",
    "strength": "0.05%",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "ENT",
    "pack": "As per regulatory specification",
    "desc": "Dexamethasone Sodium Phosphate & Chloramphenicol Eye/ear 0.05%w/v Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0703",
    "name": "Xylometazoline Hydrochloride & Benzalkonium Chloride Drops",
    "generic": "Xylometazoline Hydrochloride & Benzalkonium Chloride",
    "strength": "0.10%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "ENT",
    "pack": "As per regulatory specification",
    "desc": "Xylometazoline Hydrochloride & Benzalkonium Chloride Drops — from Exelvia's standardized export product list."
  },
  {
    "id": "ppdf0704",
    "name": "Moxifloxacin Hydrochloride",
    "generic": "Moxifloxacin Hydrochloride",
    "strength": "0.5%w/v",
    "form": "Eye/Ear Drop",
    "category": "eye-ear-drops",
    "segment": "Anti-Infectives",
    "pack": "As per regulatory specification",
    "desc": "Moxifloxacin Hydrochloride — from Exelvia's standardized export product list."
  }
];
